<template>
  <div
    class="intent-item pa-0 mb-3"
    :style="{
      border: `1px solid ${$vuetify.theme.primary}`,
      'border-left': intentStatus.isOnline ? `5px solid #a0e83d` : `5px solid red`
    }"
    style="position: relative;"
    :class="{ edit: isEdit }"
    v-if="intent"
    :id="`select_intent${intent.id}`"
    :ref="`select_intent${intent.id}`"
  >
    <div
      v-if="
        ($store.getters.getPackage != 'premium' && indexIntent > 1 && isCommentToInbox) ||
          (pageNumber > 1 && isCommentToInbox && $store.getters.getPackage != 'premium')
      "
      style="background-color: rgba(236, 236, 236, 0.74);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;"
    >
      <template>
        <div
          class="text-xs-center mt-4"
          style="margin-bottom: 25px;"
          :style="{ 'margin-top': marginTop + 'px' }"
        >
          <p style="text-shadow: rgb(80, 80, 80) 1px 1px 20px; width: 50%; margin: auto;">
            {{ $t(`upgradeReplyComments`) }}
          </p>

          <v-btn
            depressed
            style="margin-bottom:1.5em"
            :to="'/' + $i18n.locale() + '/upgrade'"
            small
            color="primary"
            >{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</v-btn
          >
        </div>
      </template>
    </div>
    <v-layout wrap v-if="!isEdit">
      <v-flex xs12 sm8>
        <v-checkbox
          v-if="
            ![
              '{default}',
              '{default_comment_to_inbox}',
              '{default_gpt}',
              '{first_announcement_message}'
            ].includes(intent.intentname) && !isLivechat
          "
          :input-value="isCheck"
          style="display: inline-block; margin: 0; float: left; padding: 6px;"
          @change="assignCb(intent.id)"
          color="primary"
          hide-details
        ></v-checkbox>
        <div v-if="!isEdit" class="text-truncate pa-2" @click="toggleDetail">
          <toggle-button
            v-if="!isBeacon"
            :value="intent.intentstatus"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeIntentStatus"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
          <toggle-button
            v-else
            :value="intent.status"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeIntentStatus"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
          <template v-if="intent.intentname == '{default}'">
            {{ $t('Default Conversation') }}
          </template>
          <template v-else-if="intent.intentname == '{default_live}'">
            {{ $t('More Live Comment') }}
          </template>
          <template v-else-if="intent.intentname == '{default_comment_to_inbox}'">
            {{ $t('More Comment to Inbox') }}
          </template>
          <template v-else-if="intent.intentname == '{first_announcement_message}'">
            {{ $t('First Announcement') }}
          </template>
          <template v-else-if="intent.intentname == '{default_gpt}'">
            ChatGPT Plus
          </template>
          <template v-else>
            <template v-if="isBeacon">
              <span>
                {{ intent.campaign_name }}
              </span>
            </template>
            <template v-else>
              <span>
                {{ intent.intentname }}
              </span>
            </template>

            <div
              style="white-space: normal;"
              class="mt-2"
              v-if="
                intent.q_val === '{meta_pay_verified}' && $store.getters.getPackage === 'premium'
              "
            >
              <small style="color:red">
                {{ $t('error_meta_verify') }}
              </small>
            </div>

            <!-- <v-icon :color="isOnline ? '#a0e83d' : 'red'">fiber_manual_record</v-icon> -->
          </template>
        </div>
      </v-flex>

      <v-flex xs12 sm4 class="text-xs-right pa-1" @click="toggleDetail">
        <div style="display: inline-block" @click.stop>
          <template v-if="isCommentToInbox && !isLiveStream">
            <v-chip label outline small disabled color="info">
              <v-premium-lock
                class="mr-2"
                v-if="
                  $store.getters.getPackage != 'premium' &&
                    !(
                      postidlist &&
                      postidlist.includes &&
                      postidlist.excludes &&
                      postidlist.post_keywords &&
                      postidlist.includes.length === 0 &&
                      postidlist.excludes.length === 0 &&
                      postidlist.post_keywords.length === 0
                    )
                "
                :inline="true"
              ></v-premium-lock>
              <IntentSelectPostLabel :value="postidlist"></IntentSelectPostLabel>
            </v-chip>

            <div class="clearfix" style="margin-bottom: 10px"></div>
          </template>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="
                  !isEdit &&
                    !isCommentToInbox &&
                    ![
                      '{default}',
                      '{default_comment_to_inbox}',
                      '{default_live}',
                      '{default_gpt}',
                      '{first_announcement_message}'
                    ].includes(intent.intentname) &&
                    $route.name != 'allinonechat' &&
                    !isBeacon
                "
                @click="testIntent()"
              >
                <v-icon small>send</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Share Ref link') }}</span>
          </v-tooltip>
          <template v-if="$route.name != 'allinonechat'">
            <template
              v-if="
                ((indexIntent >= getPackageConfig().inbox ||
                  ['{default_comment_to_inbox}'].includes(intent.intentname)) &&
                  $store.getters.getPackage != 'premium' &&
                  selectedBot.pagetype != 'enterprise') ||
                  (pageNumber > 1 && $store.getters.getPackage != 'premium')
              "
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="extra-small ma-1" readonly fab outline small color="grey" v-on="on">
                    <v-icon>lock</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Upgrade to {package} Plan', { package: 'PREMIUM' }) }}</span>
              </v-tooltip> </template
            ><template v-else>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    outline
                    color="primary"
                    class="extra-small ma-1"
                    v-if="!isEdit"
                    @click="editIntent"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </v-btn>
                </template>
                <span>{{ $t('edit') }}</span>
              </v-tooltip>
            </template>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  outline
                  color="primary"
                  class="extra-small ma-1"
                  v-if="
                    !isEdit &&
                      intent.intentname != '{default}' &&
                      ![
                        '{default_comment_to_inbox}',
                        '{default_live}',
                        '{default_gpt}',
                        '{first_announcement_message}'
                      ].includes(intent.intentname)
                  "
                  @click="onCopyMyIntent()"
                >
                  <i class="fa fa-copy middle"></i>
                </v-btn>
              </template>
              <span>{{ $t('copy') }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                !(
                  ['111', '112', '113'].includes(selectedBot.selected_presets) &&
                  $store.state.presetIntentName.includes(intent.intentname)
                )
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  outline
                  color="primary"
                  class="extra-small ma-1"
                  v-if="
                    !isEdit &&
                      intent.intentname != '{default}' &&
                      ![
                        '{default_comment_to_inbox}',
                        '{default_live}',
                        '{default_gpt}',
                        '{first_announcement_message}'
                      ].includes(intent.intentname)
                  "
                  @click="$emit('onDelete')"
                >
                  <i class="fa fa-trash middle"></i>
                </v-btn>
              </template>
              <span>{{ $t('Delete') }}</span>
            </v-tooltip>
          </template>
          <template v-else-if="isLivechat">
            <v-btn @click="isEdit = true" depressed color="primary">{{ $t('Edit/Send') }}</v-btn>
            <v-btn depressed color="primary" @click="sendToLivechat(intent)">{{
              $t('Send')
            }}</v-btn>
          </template>
        </div>
      </v-flex>
      <v-flex xs12 class="grey--text text--lighten-1 caption pa-1" @click="toggleDetail">
        <div v-if="intent.updated_at">
          {{ intent.updated_at | DateFormat('DD/MM/YYYY hh:mm A') }}
        </div>
        <div v-else-if="intent.created_at">
          {{ intent.created_at | DateFormat('DD/MM/YYYY hh:mm A') }}
        </div>
        <div v-if="intent.updated_by">{{ $t('Updated by') + ' ' }} {{ adminName }}</div>
        <div v-else-if="intent.created_by">{{ $t('Created by') + ' ' }} {{ adminName }}</div>
      </v-flex>
      <v-flex xs10 class="pa-1" @click="toggleDetail">
        <template v-if="showMultipleChannel">
          <v-avatar size="24" color="#4267B2" v-if="channels.includes('facebook')"
            ><i class="white--text fab fa-facebook-square"></i
          ></v-avatar>
          <v-tooltip top :disabled="check_privilege('line')">
            <template v-slot:activator="{ on }">
              <v-avatar
                v-on="on"
                size="24"
                :color="check_privilege('line') ? '#00c300' : 'grey'"
                v-if="channels.includes('line')"
                ><i class="white--text fab fa-line"></i
              ></v-avatar>
            </template>
            <span>{{ $t('inactive') }}</span>
          </v-tooltip>

          <v-tooltip top :disabled="check_privilege('instagram')">
            <template v-slot:activator="{ on }">
              <v-avatar
                size="24"
                v-on="on"
                :color="check_privilege('instagram') ? '#C13584' : 'grey'"
                v-if="channels.includes('instagram')"
                ><i class="white--text fab fa-instagram"></i
              ></v-avatar>
            </template>
            <span>{{ $t('inactive') }}</span>
          </v-tooltip>

          <v-tooltip top :disabled="check_privilege('whatsapp')">
            <template v-slot:activator="{ on }">
              <v-avatar
                size="24"
                v-on="on"
                :color="check_privilege('whatsapp') ? '#00c300' : 'grey'"
                v-if="channels.includes('whatsapp')"
                ><i class="white--text fab fa-whatsapp"></i
              ></v-avatar>
            </template>
            <span>{{ $t('inactive') }}</span>
          </v-tooltip>

          <v-tooltip top :disabled="check_privilege('google')">
            <template v-slot:activator="{ on }">
              <v-avatar
                size="24"
                v-on="on"
                :color="check_privilege('google') ? '#F4B400' : 'grey'"
                v-if="channels.includes('google')"
              >
                <i class="white--text fab fa-google"></i>
              </v-avatar>
            </template>
            <span>{{ $t('inactive') }}</span>
          </v-tooltip>
        </template>
        <v-chip
          small
          color="#00c300"
          text-color="white"
          v-if="
            $store.state.linenotifylist.length > 0 &&
              ((intent.linenoti_status && selectedBot.notify_intent && !isCommentToInbox) ||
                (intent.linenoti_status && selectedBot.notify_comment && isCommentToInbox))
          "
          disabled
        >
          <v-avatar>
            <i class="fas fa-bell"></i>
          </v-avatar>
          {{ $t('Line Notify') }}
        </v-chip>

        <div v-if="intent.onlytime === null">
          <template v-for="(item, index) in timeSetting">
            <v-tooltip :key="`item-time-${index}`" top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  small
                  :color="
                    item.isToday && item.isActive
                      ? '#a0e83d'
                      : item.isToday && !item.isActive
                      ? 'red'
                      : ''
                  "
                  text-color="white"
                  :disabled="!item.isToday"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.day }}
                </v-chip>
              </template>
              <span>{{ item.status ? item.timeLength : $t('Not activated') }}</span>
            </v-tooltip>
          </template>
        </div>
        <template v-else>
          <v-chip
            small
            :color="intentStatus.isStarttime ? '#a0e83d' : 'red'"
            text-color="white"
            v-if="intent.starttime"
            disabled
          >
            <v-avatar>
              <v-icon>access_time</v-icon>
            </v-avatar>
            <template>
              Start
              <template v-if="intent.onlytime">
                {{ intent.starttime | DateFormat('HH:mm') }}
              </template>
              <template v-else>{{ intent.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
            </template>
          </v-chip>
          <v-chip
            small
            :color="intentStatus.isEndtime ? '#a0e83d' : 'red'"
            text-color="white"
            v-if="intent.endtime"
            disabled
          >
            <v-avatar>
              <v-icon>access_time</v-icon>
            </v-avatar>
            <template>
              End
              <template v-if="intent.onlytime">{{ intent.endtime | DateFormat('HH:mm') }}</template>
              <template v-else>{{ intent.endtime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
            </template>
          </v-chip>
        </template>
      </v-flex>
      <v-flex xs2 class="text-xs-right pa-1" @click="toggleDetail">
        <template v-if="!isEdit && intent.intentname != '{default_gpt}'">
          <div>
            <span
              class="fas"
              :style="
                `font-size: 1.5em;margin-right: 5px; cursor: pointer; color: ${$vuetify.theme.primary}`
              "
              :class="{ 'fa-chevron-down': !showDetail, 'fa-chevron-up': showDetail }"
            ></span>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="isEdit || showDetail">
      <template v-if="isEdit">
        <manage-intent
          v-if="!isBeacon"
          :isIntent="isIntent"
          :type="'edit'"
          :isLivechat="isLivechat"
          :isLiveStream="isLiveStream"
          :isCommentToInbox="isCommentToInbox"
          v-model="intent"
          @close="onClose"
          @saveIntent="onSave"
          @sendToLivechat="sendToLivechat"
          :isDefault="
            intent.intentname == '{default}' ||
              [
                '{default_comment_to_inbox}',
                '{default_live}',
                '{first_announcement_message}'
              ].includes(intent.intentname)
          "
          :excludedIntentName="excludedIntentName"
          :hasTypeDateAndTime="
            isConversation ||
              isComment ||
              intent.intentname === '{default_comment_to_inbox}' ||
              intent.intentname === '{default}'
          "
        ></manage-intent>
        <manage-intent
          v-else
          :isIntent="isIntent"
          :type="'edit'"
          :isCommentToInbox="false"
          v-model="intent"
          @close="onClose"
          @saveIntent="onSave"
          :excludedIntentName="excludedIntentName"
          :isBeacon="isBeacon"
        ></manage-intent>
      </template>
      <template v-else>
        <v-divider></v-divider>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <div class="question pa-2">
              <template v-if="intent.intentname == '{default}'"></template>
              <template
                v-else-if="
                  [
                    '{default_comment_to_inbox}',
                    '{default_live}',
                    '{default_gpt}',
                    '{first_announcement_message}'
                  ].includes(intent.intentname)
                "
              ></template>
              <template v-else>
                <p>{{ isBeacon ? 'รูปแบบการส่ง' : $t('customer says') }}</p>

                <template v-if="dataVerifySlip && dataVerifySlip.length > 0">
                  <h3 class="mt-2 mb-1" style="color:#000">
                    {{ $t('payment_method') }}
                    <span v-if="isMetaVerifySlip">Basic Slip Verification</span>
                  </h3>

                  <div
                    class="form-control intent-item z-border-red pa-3"
                    v-for="(item, index) in dataVerifySlip"
                    :key="index"
                  >
                    <div
                      style="text-align: right; color:#fb8c00 "
                      v-if="item.status && item.status === 'pending'"
                    >
                      <small class="mr-2">ยังไม่ได้ยืนยันบัญชีบน META Business Suite</small>
                      <i
                        class="fas fa-info-circle"
                        style=" font-size: 20px; vertical-align: middle;"
                        v-tooltip.top="$t('verify_on_meta')"
                      ></i>
                    </div>
                    <i
                      v-if="item.status && item.status === 'verified'"
                      class="fas fa-check-circle green--text"
                      style="float: right; font-size: 20px;"
                      v-tooltip.top="$t('Verified by Meta')"
                    ></i>

                    <template v-if="item.typeAccount && item.typeAccount.value === 'all'">
                      <h4>
                        {{ $t('bank_name') }} : <span> {{ $t('not_specified_account') }} </span>
                      </h4>
                    </template>
                    <template v-else>
                      <v-layout wrap>
                        <v-flex xs2>
                          <img
                            v-if="item.bankName && item.bankName === 'promptpay'"
                            style="width: 40px;"
                            :src="'/static/img/assets/payment/logo_e_wallet/ewallet.png'"
                          />
                          <img
                            v-else
                            style="width: 40px;"
                            :src="
                              getBankName(item.bankName)
                                ? getBankName(item.bankName).image
                                : '/static/img/assets/_global/default-photo.png'
                            "
                          />
                        </v-flex>
                        <v-flex xs10>
                          <div>
                            <h4 v-if="item.bankName && item.bankName === 'promptpay'">
                              {{ $t('promptpay') }}
                            </h4>
                            <h4 v-else>
                              {{ $t('bank_name') }} :
                              <span v-if="getBankName(item.bankName)">{{
                                getBankName(item.bankName).name_th
                              }}</span>
                            </h4>
                          </div>
                          <div style="font-size: 90%;">
                            <div>
                              <span v-if="item.bankName && item.bankName === 'transfer'">
                                {{ $t('bank_account') }} :
                              </span>
                              <span v-else-if="item.bankName && item.bankName === 'promptpay'">
                                {{ $t('promptpay_code') }} :</span
                              >
                              <span
                                v-else-if="item.typeAccount && item.typeAccount.value === 'eWallet'"
                              >
                                {{ $t('E-Wallet ID') }}
                              </span>
                              <span
                                v-else-if="
                                  item.typeAccount && item.typeAccount.value === 'paymentGateway'
                                "
                              >
                                {{ $t('Biller ID') }}
                              </span>
                              <span v-else> {{ $t('bank_account_no') }} :</span>
                              <span
                                ><template v-if="isMetaVerifySlip">xxxxxx</template
                                >{{ item.bankAccountNo }}</span
                              >
                            </div>
                            <div>
                              <span> {{ $t('receiver_name') }} :</span>
                              <span v-if="isMetaVerifySlip"> {{ item.name }} </span>
                              <template v-else>
                                <template v-if="item.keyword && item.keyword.length > 0">
                                  <span
                                    v-for="(val, index) in item.keyword"
                                    :key="`name_text_${index}`"
                                  >
                                    {{ val.text }}
                                    <span v-if="index !== item.keyword.length - 1">,</span></span
                                  >
                                </template>
                                <span v-else> -</span>
                              </template>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </template>
                  </div>
                  <div style="text-align: right;" v-if="isMetaVerifySlip">
                    <v-btn
                      outline
                      color="primary"
                      @click="
                        openLink(
                          `https://business.facebook.com/latest/orders/payment_settings?asset_id=${selectedBot.pageid}&nav_ref=add_accounts_slip_verification`
                        )
                      "
                      >{{ $t('confirm_account') }}</v-btn
                    >
                  </div>
                </template>
                <template v-else>
                  <template v-if="normal && normal.length > 0">
                    <label class="caption">{{ $t('Sentence') }}</label>
                    <ul class="tags" style="margin-bottom: 5px">
                      <!-- :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`" -->
                      <li
                        class="tag"
                        :style="
                          `border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`
                        "
                        v-for="(question, index) in normal"
                        :key="'normal_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template v-if="keyword && keyword.length > 0">
                    <label class="caption">{{ $t('Keyword') }}</label>
                    <ul class="tags" style="margin-bottom: 5px">
                      <li
                        class="tag"
                        :style="
                          `border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`
                        "
                        v-for="(question, index) in keyword"
                        :key="'keyword_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template v-if="exactly && exactly.length > 0">
                    <label v-if="!isBeacon" class="caption">{{ $t('Exact word') }}</label>
                    <ul class="tags" style="margin-bottom: 5px">
                      <li
                        class="tag"
                        v-for="(question, index) in exactly"
                        :key="'exactly_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template v-if="isBeacon">
                    <p>ชื่อ Beacon ที่ตอบ</p>
                    <ul class="tags" style="margin-bottom: 5px">
                      <li class="tag" v-for="(item, index) in specificBeaconIds" :key="index">
                        <specialtext :text="item"></specialtext>
                      </li>
                    </ul>
                  </template>
                  <template
                    v-if="
                      startwith && startwith.length > 0 && $store.getters.getPackage == 'premium'
                    "
                  >
                    <label class="caption">{{ $t('Start with') }}</label>
                    <ul class="tags" style="margin-bottom: 5px">
                      <li
                        class="tag"
                        v-for="(question, index) in startwith"
                        :key="'startwith_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template
                    v-if="endwith && endwith.length > 0 && $store.getters.getPackage == 'premium'"
                  >
                    <label class="caption">{{ $t('End with') }}</label>
                    <ul class="tags" style="margin-bottom: 5px">
                      <li
                        class="tag"
                        v-for="(question, index) in endwith"
                        :key="'endwith_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>
                  <template
                    v-if="
                      startandendwith &&
                        startandendwith.length > 0 &&
                        $store.getters.getPackage == 'premium'
                    "
                  >
                    <label class="caption">{{ $t('Start and End with') }}</label>
                    <ul class="tags" style="margin-bottom: 5px">
                      <li
                        class="tag"
                        v-for="(question, index) in startandendwith"
                        :key="'startandendwith_question_' + index"
                        :class="{ disabled: !question.checkLang }"
                      >
                        <specialtext :text="question.text"></specialtext>
                        <i class="mark fas fa-exclamation-circle"></i>
                      </li>
                    </ul>
                  </template>

                  <label v-show="isOtherLang && $store.getters.getPackage != 'premium'">
                    <i class="fas fa-exclamation-circle"></i>
                    {{
                      $t(
                        'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
                      )
                    }}
                  </label>
                </template>
              </template>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <template v-if="answers">
              <div class="answer pa-2">
                <template v-if="isCommentToInbox">
                  <p>{{ $t('Chatbot answers') }}</p>
                  <template v-if="!showMultipleChannel">
                    <template v-if="answers && answers[0].length > 0">
                      <message-viewer
                        v-model="answers"
                        :quick_reply="intent.quick_reply"
                        :channel="tab"
                      ></message-viewer>
                    </template>
                    <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                  </template>
                </template>
                <template v-else>
                  <p>{{ $t('Chatbot answers') }}</p>
                  <template v-if="intent.a_type == 'json' && isVerifySlip">
                    <template v-if="!showMultipleChannel">
                      <intent-verify-slip
                        :correct="messages_correct"
                        :incorrect="messages_incorrect"
                        :err="messages_error"
                        :duplicate="messages_duplicate"
                        readonly
                      >
                      </intent-verify-slip>
                    </template>
                    <template v-else>
                      <v-layout>
                        <v-flex class="channel" shrink style="border-right: 1px solid #eee">
                          <div
                            v-if="channels.includes('facebook')"
                            :class="{ 'primary white--text': tab == 'facebook' }"
                            @click="onChangeChannel('facebook')"
                            class="tab-channel"
                          >
                            <div class="lock" v-if="getChannelDisabled('facebook')">
                              <v-premium-lock2
                                type="advanced"
                                text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                              ></v-premium-lock2>
                            </div>
                            <span class="fab fa-facebook"></span>
                          </div>
                          <div
                            v-if="channels.includes('line')"
                            :class="{ 'primary white--text': tab == 'line' }"
                            @click="onChangeChannel('line')"
                            class="tab-channel"
                          >
                            <div class="lock" v-if="getChannelDisabled('line')">
                              <v-premium-lock2
                                type="advanced"
                                text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                              ></v-premium-lock2>
                            </div>
                            <span class="fab fa-line"></span>
                          </div>
                          <div
                            v-if="channels.includes('instagram')"
                            :class="{ 'primary white--text': tab == 'instagram' }"
                            @click="onChangeChannel('instagram')"
                            class="tab-channel"
                          >
                            <div class="lock" v-if="getChannelDisabled('instagram')">
                              <v-premium-lock2
                                type="advanced"
                                text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                              ></v-premium-lock2>
                            </div>
                            <span class="fab fa-instagram"></span>
                          </div>
                          <div
                            v-if="channels.includes('whatsapp')"
                            :class="{ 'primary white--text': tab == 'whatsapp' }"
                            @click="onChangeChannel('whatsapp')"
                            class="tab-channel"
                          >
                            <div class="lock" v-if="getChannelDisabled('whatsapp')">
                              <v-premium-lock2
                                type="advanced"
                                text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                              ></v-premium-lock2>
                            </div>
                            <span class="fab fa-whatsapp"></span>
                          </div>
                          <div
                            v-if="channels.includes('google')"
                            :class="{ 'primary white--text': tab == 'google' }"
                            @click="onChangeChannel('google')"
                            class="tab-channel"
                          >
                            <div class="lock" v-if="getChannelDisabled('google')">
                              <v-premium-lock2
                                type="advanced"
                                text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                              ></v-premium-lock2>
                            </div>
                            <span class="fab fa-google"></span>
                          </div>
                        </v-flex>
                        <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                          <template v-if="tab == 'facebook'">
                            <template
                              v-if="
                                fb_messages_correct &&
                                  fb_messages_incorrect &&
                                  fb_messages_error &&
                                  fb_messages_correct[0].length > 0 &&
                                  fb_messages_incorrect[0].length > 0 &&
                                  fb_messages_error[0].length > 0 &&
                                  fb_messages_duplicate[0].length > 0
                              "
                            >
                              <intent-verify-slip
                                :correct="fb_messages_correct"
                                :incorrect="fb_messages_incorrect"
                                :err="fb_messages_error"
                                :duplicate="fb_messages_duplicate"
                                :channel="tab"
                                readonly
                              >
                              </intent-verify-slip>
                            </template>
                            <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                          </template>
                          <template v-else-if="tab == 'line'">
                            <template
                              v-if="
                                line_messages_correct &&
                                  line_messages_incorrect &&
                                  line_messages_error &&
                                  line_messages_correct[0].length > 0 &&
                                  line_messages_incorrect[0].length > 0 &&
                                  line_messages_error[0].length > 0 &&
                                  line_messages_duplicate[0].length > 0
                              "
                            >
                              <intent-verify-slip
                                :correct="line_messages_correct"
                                :incorrect="line_messages_incorrect"
                                :err="line_messages_error"
                                :duplicate="line_messages_duplicate"
                                :channel="tab"
                                readonly
                              >
                              </intent-verify-slip>

                              <v-premium-lock2
                                :value="!check_privilege('line')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{
                                  $t('Upgrade to {package} Plan', { package: $t('PREMIUM') })
                                }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                          </template>
                          <template v-else-if="tab == 'whatsapp'">
                            <template
                              v-if="
                                whatsapp_messages_correct &&
                                  whatsapp_messages_incorrect &&
                                  whatsapp_messages_error &&
                                  whatsapp_messages_correct[0].length > 0 &&
                                  whatsapp_messages_incorrect[0].length > 0 &&
                                  whatsapp_messages_error[0].length > 0 &&
                                  whatsapp_messages_duplicate[0].length > 0
                              "
                            >
                              <intent-verify-slip
                                :correct="whatsapp_messages_correct"
                                :incorrect="whatsapp_messages_incorrect"
                                :err="whatsapp_messages_error"
                                :duplicate="whatsapp_messages_duplicate"
                                :channel="tab"
                                readonly
                              >
                              </intent-verify-slip>

                              <v-premium-lock2
                                :value="!check_privilege('whatsapp')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{
                                  $t('Upgrade to {package} Plan', { package: $t('PREMIUM') })
                                }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                          </template>
                          <template v-else-if="tab == 'instagram'">
                            <template
                              v-if="
                                ig_messages_correct &&
                                  ig_messages_incorrect &&
                                  ig_messages_error &&
                                  ig_messages_correct[0].length > 0 &&
                                  ig_messages_incorrect[0].length > 0 &&
                                  ig_messages_error[0].length > 0 &&
                                  ig_messages_duplicate[0].length > 0
                              "
                            >
                              <intent-verify-slip
                                :correct="ig_messages_correct"
                                :incorrect="ig_messages_incorrect"
                                :err="ig_messages_error"
                                :duplicate="ig_messages_duplicate"
                                :channel="tab"
                                readonly
                              >
                              </intent-verify-slip>

                              <v-premium-lock2
                                :value="!check_privilege('instagram')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                          </template>
                          <template v-else-if="tab == 'google'">
                            <template
                              v-if="
                                google_messages_correct &&
                                  google_messages_incorrect &&
                                  google_messages_error &&
                                  google_messages_correct[0].length > 0 &&
                                  google_messages_incorrect[0].length > 0 &&
                                  google_messages_error[0].length > 0 &&
                                  google_messages_duplicate[0].length > 0
                              "
                            >
                              <intent-verify-slip
                                :correct="google_messages_correct"
                                :incorrect="google_messages_incorrect"
                                :err="google_messages_error"
                                :duplicate="google_messages_duplicate"
                                :channel="tab"
                                readonly
                              >
                              </intent-verify-slip>

                              <v-premium-lock2
                                :value="!check_privilege('google')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                          </template>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                  <template v-else-if="intent.a_type == 'json'">
                    <div>
                      <template v-if="!showMultipleChannel">
                        <template v-if="answers && answers[0].length > 0">
                          <div
                            style="white-space: pre-line;"
                            v-if="intent.intentname === '{default_gpt}'"
                          >
                            {{ answers.join('\n') }}
                          </div>
                          <message-viewer v-model="answers" :channel="tab" v-else></message-viewer>
                        </template>
                        <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                      </template>
                      <template v-else>
                        <v-layout>
                          <v-flex class="channel" shrink style="border-right: 1px solid #eee">
                            <div
                              v-if="channels.includes('facebook')"
                              :class="{ 'primary white--text': tab == 'facebook' }"
                              @click="onChangeChannel('facebook')"
                              class="tab-channel"
                            >
                              <div class="lock" v-if="getChannelDisabled('facebook')">
                                <v-premium-lock2
                                  type="advanced"
                                  text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                                ></v-premium-lock2>
                              </div>
                              <span class="fab fa-facebook"></span>
                            </div>
                            <div
                              v-if="channels.includes('line')"
                              :class="{ 'primary white--text': tab == 'line' }"
                              @click="onChangeChannel('line')"
                              class="tab-channel"
                            >
                              <div class="lock" v-if="getChannelDisabled('line')">
                                <v-premium-lock2
                                  type="advanced"
                                  text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                                ></v-premium-lock2>
                              </div>
                              <span class="fab fa-line"></span>
                            </div>
                            <div
                              v-if="channels.includes('instagram')"
                              :class="{ 'primary white--text': tab == 'instagram' }"
                              @click="onChangeChannel('instagram')"
                              class="tab-channel"
                            >
                              <div class="lock" v-if="getChannelDisabled('instagram')">
                                <v-premium-lock2
                                  type="advanced"
                                  text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                                ></v-premium-lock2>
                              </div>
                              <span class="fab fa-instagram"></span>
                            </div>
                            <div
                              v-if="channels.includes('whatsapp')"
                              :class="{ 'primary white--text': tab == 'whatsapp' }"
                              @click="onChangeChannel('whatsapp')"
                              class="tab-channel"
                            >
                              <div class="lock" v-if="getChannelDisabled('whatsapp')">
                                <v-premium-lock2
                                  type="advanced"
                                  text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                                ></v-premium-lock2>
                              </div>
                              <span class="fab fa-whatsapp"></span>
                            </div>
                            <div
                              v-if="channels.includes('google')"
                              :class="{ 'primary white--text': tab == 'google' }"
                              @click="onChangeChannel('google')"
                              class="tab-channel"
                            >
                              <div class="lock" v-if="getChannelDisabled('google')">
                                <v-premium-lock2
                                  type="advanced"
                                  text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                                ></v-premium-lock2>
                              </div>
                              <span class="fab fa-google"></span>
                            </div>
                          </v-flex>
                          <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                            <template v-if="tab == 'facebook'">
                              <template v-if="fbanswers && fbanswers[0].length > 0">
                                <message-viewer v-model="fbanswers" :channel="tab"></message-viewer>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                            <template v-else-if="tab == 'line'">
                              <template v-if="lineanswers && lineanswers[0].length > 0">
                                <message-viewer
                                  v-model="lineanswers"
                                  :channel="tab"
                                ></message-viewer>

                                <v-premium-lock2
                                  :value="!check_privilege('line')"
                                  type="premium"
                                  class="mt-2"
                                >
                                  <span class="pl-2">{{
                                    $t('Upgrade to {package} Plan', { package: $t('PREMIUM') })
                                  }}</span>
                                </v-premium-lock2>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                            <template v-else-if="tab == 'whatsapp'">
                              <template v-if="whatsappanswers && whatsappanswers[0].length > 0">
                                <message-viewer
                                  v-model="whatsappanswers"
                                  :channel="tab"
                                ></message-viewer>

                                <v-premium-lock2
                                  :value="!check_privilege('whatsapp')"
                                  type="premium"
                                  class="mt-2"
                                >
                                  <span class="pl-2">{{
                                    $t('Upgrade to {package} Plan', { package: $t('PREMIUM') })
                                  }}</span>
                                </v-premium-lock2>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                            <template v-else-if="tab == 'instagram'">
                              <template v-if="iganswers && iganswers[0].length > 0">
                                <message-viewer v-model="iganswers" :channel="tab"></message-viewer>

                                <v-premium-lock2
                                  :value="!check_privilege('instagram')"
                                  type="premium"
                                  class="mt-2"
                                >
                                  <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                                </v-premium-lock2>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                            <template v-else-if="tab == 'google'">
                              <template v-if="googleAnswers && googleAnswers[0].length > 0">
                                <message-viewer
                                  v-model="googleAnswers"
                                  :channel="tab"
                                ></message-viewer>

                                <v-premium-lock2
                                  :value="!check_privilege('google')"
                                  type="premium"
                                  class="mt-2"
                                >
                                  <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                                </v-premium-lock2>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                          </v-flex>
                        </v-layout>
                      </template>
                    </div>
                  </template>
                  <template v-else-if="intent.a_type == 'text'">
                    <div style="overflow-x: auto">
                      <div>
                        <div
                          v-for="(answer, index) in answers"
                          :key="'answer_' + index"
                          style="margin-bottom: 5px; flex-grow: 1; padding: 0px 10px"
                          :style="{ 'border-right': answers.length > 1 ? '1px dashed #eee' : '' }"
                        >
                          <div v-for="(message, mindex) in answer" :key="'message_' + mindex">
                            <template v-if="message.type == 'text'">
                              <div
                                class="message"
                                style="
                                  float: left;
                                  position: relative;
                                  border-radius: 12px;
                                  max-width: 181px;
                                  overflow-wrap: break-word;
                                  min-height: 22px;
                                  min-width: 14px;
                                  line-height: 15.36px;
                                  overflow: hidden;
                                  margin-bottom: 5px;
                                "
                              >
                                <div style="font-size: 12px; color: black">
                                  <div style="padding: 5px 8px 6px; background-color: #f1f0f0">
                                    <span style="line-height: 15.36px">
                                      <specialtext :text="message.value.text"></specialtext>
                                    </span>
                                  </div>
                                </div>
                                <div class="clearfix"></div>
                                <div
                                  v-if="message.value.buttons.length > 0"
                                  style="
                                    float: left;
                                    width: 100%;
                                    border: 1px solid #eee;
                                    border-bottom-left-radius: 12px;
                                    border-bottom-right-radius: 12px;
                                    overflow: hidden;
                                  "
                                >
                                  <ul
                                    class="list-group list-group-flush"
                                    style="margin-bottom: 0px"
                                  >
                                    <li
                                      class="list-group-item"
                                      style="
                                        border: none;
                                        border-top: 1px solid #eee;
                                        border-radius: 0px;
                                        text-align: center;
                                        padding: 2px 15px;
                                      "
                                      v-for="(button, bindex) in message.value.buttons"
                                      :key="bindex"
                                      :style="{
                                        'border-top': bindex != 0 ? '1px solid #eee' : 'none'
                                      }"
                                    >
                                      <span style="color: #0084ff">{{ button.title }}</span>
                                      <p style="margin: 0; font-size: 10px">
                                        <template v-if="button.type == 'web_url'">
                                          {{ button.url }}
                                        </template>
                                        <template v-if="button.type == 'postback'">
                                          {{ button.payload }}
                                        </template>
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="message.type == 'image'">
                              <div
                                class="message"
                                style="
                                  float: left;
                                  position: relative;
                                  border-radius: 12px;
                                  width: 181px;
                                  overflow-wrap: break-word;
                                  min-height: 22px;
                                  min-width: 14px;
                                  line-height: 15.36px;
                                  overflow: hidden;
                                  margin-bottom: 5px;
                                "
                              >
                                <div style="font-size: 12px; color: black">
                                  <img :src="message.value" alt style="width: 100%" />
                                </div>
                              </div>
                            </template>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="intent.a_type == 'template'">
                    <generic-viewer v-model="answers"></generic-viewer>
                  </template>
                  <template v-else-if="intent.a_type == 'message' || intent.a_type == 'generic'">
                    <intent-getstarted v-model="welcomemessage"></intent-getstarted>
                  </template>
                  <template v-else-if="intent.a_type == 'viewsummary'">
                    <view-cart-summary-viewer></view-cart-summary-viewer>
                  </template>
                  <template v-else-if="intent.a_type == 'none'" class="pl-1">{{
                    $t('No reply')
                  }}</template>
                </template>

                <template>
                  <div
                    v-if="
                      !isCommentToInbox &&
                        tab !== 'whatsapp' &&
                        intent.intentname !== '{default_gpt}'
                    "
                  >
                    <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                    <div class="quickreply">
                      <template v-if="replies.length > 0">
                        <ul class="tags">
                          <li class="tag" v-for="(reply, index) in replies" :key="'reply_' + index">
                            {{ reply }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>-</template>
                    </div>
                  </div>
                </template>

                <!-- <template v-if="isBeacon">
                  <p class="caption mt-2">{{ $t('จำนวนครั้งที่ส่งข้อความสูงสุดต่อวัน') }}</p>
                  {{ intent.frequency_per_day || '-' }}
                </template> -->
              </div>
            </template>
          </v-flex>
        </v-layout>
        <template v-if="intent.intentname !== '{default_gpt}'">
          <div
            v-if="
              follow_up_quick_reply ||
                follow_up_val ||
                follow_up_within_seconds ||
                intent.not_reply_within_seconds ||
                intent.not_reply_within_times ||
                intent.userstatus ||
                (intent.linenoti_status &&
                  intent.linenoti_text &&
                  intent.linenoti_text.trim() != '') ||
                (intent.context_in && !['comment', 'facebooklive'].includes(intent.context_in)) ||
                intent.context_out ||
                (usertags && usertags.length > 0) ||
                intent.remaining_reply != null ||
                intent.hasOwnProperty('notreplysameperson')
            "
          >
            <v-divider></v-divider>

            <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
              <v-tab :key="0" :href="'#tab-0'" ripple>{{ $t('Customer') }}</v-tab>
              <template v-if="intent.intentname !== '{first_announcement_message}'">
                <v-tab :key="1" :href="'#tab-1'" ripple v-if="!isCommentToInbox && !isBeacon">
                  {{ $t('Context') }}
                </v-tab>
                <v-tab :key="2" :href="'#tab-2'" ripple v-if="!isWelcome">
                  {{ $t('Timer') }}
                </v-tab>
                <v-tab v-if="!isBeacon" :key="3" :href="'#tab-3'" ripple>
                  {{ $t('Line Notify') }}
                </v-tab>
                <v-tab
                  :key="4"
                  :href="'#tab-4'"
                  v-if="
                    isCommentToInbox &&
                      !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname) &&
                      !isLivechat &&
                      !isBeacon
                  "
                  ripple
                >
                  {{ $t('Limit reply to inbox') }}
                </v-tab>
                <v-tab v-if="!isBeacon" :key="5" :href="'#tab-5'" ripple>
                  {{ $t('priority') }}
                </v-tab>
                <v-tab v-if="isBeacon" :key="6" :href="'#tab-6'" ripple>
                  {{ $t('frequency') }}
                </v-tab>
                <v-tab
                  v-if="
                    !isBeacon &&
                      !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                  "
                  :key="7"
                  :href="'#tab-7'"
                  ripple
                  >{{ $t('Follow Up') }}
                </v-tab>
                <v-tab
                  v-if="
                    !isBeacon &&
                      !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                  "
                  :key="8"
                  :href="'#tab-8'"
                  ripple
                  >{{ $t('purchase_event') }}
                </v-tab>
              </template>

              <v-tab-item :key="0" :value="'tab-0'">
                <v-card flat>
                  <v-card-text>
                    <div>
                      <div class="caption">{{ $t('Status') }}</div>
                      <p class="primary-color">{{ intent.userstatus ? intent.userstatus : '-' }}</p>
                    </div>
                    <div>
                      <div class="caption">{{ $t('Tag') }}</div>
                      <ul class="tags pt-1">
                        <li
                          class="tag"
                          v-for="(usertag, index) in usertags"
                          :key="'usertag_' + index"
                        >
                          <specialtext :text="usertag"></specialtext>
                        </li>
                      </ul>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="1" :value="'tab-1'" v-if="!isCommentToInbox">
                <v-card flat>
                  <v-card-text>
                    <v-layout>
                      <template v-if="!['comment', 'facebooklive'].includes(intent.context_in)">
                        <v-flex>
                          <div class="caption">Context In</div>
                          <p class="primary-color">
                            {{ intent.context_in ? $t(intent.context_in) : '-' }}
                          </p>
                        </v-flex>
                      </template>
                      <template>
                        <v-flex>
                          <div class="caption">Context Out</div>
                          <p class="primary-color">
                            {{ intent.context_out ? $t(intent.context_out) : '-' }}
                          </p>
                        </v-flex>
                      </template>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="2" :value="'tab-2'" v-if="!isWelcome">
                <v-card flat>
                  <v-card-text>
                    <div class="caption">{{ $t('Timer') }}</div>
                    <p class="primary--text">
                      {{
                        intent.onlytime
                          ? $t(`Selecting certain chatbot's answers for the certain time`)
                          : intent.onlytime === null
                          ? $t(`Select by date and time`)
                          : intent.onlytime === false
                          ? $t(`Turn On/Off Date & Time Setting for Bot's Reply`)
                          : '-'
                      }}
                    </p>
                    <template v-if="intent.onlytime">
                      <v-layout>
                        <v-flex xs6>
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                          <p class="primary-color">
                            {{ intent.starttime ? dayjs(intent.starttime).format('HH:mm') : '-' }}
                          </p>
                        </v-flex>
                        <v-flex xs6>
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                          <p class="primary-color">
                            {{ intent.endtime ? dayjs(intent.endtime).format('HH:mm') : '-' }}
                          </p>
                        </v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="intent.onlytime === false">
                      <v-layout>
                        <v-flex xs6>
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                          <p class="primary-color">
                            {{
                              intent.starttime
                                ? dayjs(intent.starttime).format('DD/MM/YYYY HH:mm')
                                : '-'
                            }}
                          </p>
                        </v-flex>
                        <v-flex xs6>
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                          <p class="primary-color">
                            {{
                              intent.endtime
                                ? dayjs(intent.endtime).format('DD/MM/YYYY HH:mm')
                                : '-'
                            }}
                          </p>
                        </v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="intent.onlytime === null && intent.time_setting">
                      <v-layout>
                        <v-flex>
                          <v-card class="mt-2 pa-3">
                            <div class="pa-2 hidden-xs-only">
                              <v-layout wrap>
                                <v-flex xs4 class="text-xs-center strong">
                                  {{ $t('Date_1') }}
                                </v-flex>
                                <v-flex xs4 class="text-xs-center strong">
                                  {{ $t('Open at') }}
                                </v-flex>
                                <v-flex xs4 class="text-xs-center strong">
                                  {{ $t('Close at') }}
                                </v-flex>
                              </v-layout>
                            </div>
                            <v-divider></v-divider>
                            <template v-for="(time, key) in intent.time_setting">
                              <open-time-bot-item
                                :key="key"
                                v-model="intent.time_setting[key]"
                                :name="key"
                                :isEdit="false"
                              ></open-time-bot-item>
                            </template>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="3" :value="'tab-3'">
                <v-card flat>
                  <v-card-text>
                    <div class="caption">{{ $t('Line Notify') }}</div>
                    <div class="primary-color">
                      {{ intent.linenoti_text ? intent.linenoti_text : '-' }}
                    </div>

                    <template v-if="intent.linenoti_spec_ids">
                      <div class="caption">{{ $t('Who to notify') }}</div>
                      <template v-for="linenotify in $store.state.linenotifylist">
                        <template v-if="intent.linenoti_spec_ids.indexOf(linenotify.id) != -1">
                          <v-chip :key="linenotify.id" class="v-chip--select-multi">
                            <v-avatar>
                              <img
                                :src="
                                  `https://graph.facebook.com/${linenotify.adminid}/picture?type=square&SameSite=None`
                                "
                              />
                            </v-avatar>
                            {{ linenotify.name }}
                          </v-chip>
                        </template>
                      </template>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="4" :value="'tab-4'">
                <v-card
                  flat
                  :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div class="col s12 form-control">
                      <div class="caption">{{ $t('Reply to comment (amount)') }}</div>
                      <p class="primary-color">
                        {{ intent.remaining_reply != null ? intent.remaining_reply : '-' }}
                      </p>

                      <div class="caption">{{ $t('Reply once/person') }}</div>
                      <p class="primary-color">
                        {{ intent.notreplysameperson ? $t('active') : $t('inactive') }}
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="5" :value="'tab-5'">
                <v-card
                  flat
                  :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
                >
                  <v-card-text>
                    <div>
                      <v-checkbox
                        class="mt-1 mb-1 pr-2"
                        v-model="intent.ispriority"
                        disabled
                        :label="$t('First Priority')"
                      ></v-checkbox>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="isBeacon" :key="6" :value="'tab-6'">
                <v-card flat>
                  <v-card-text>
                    <div>
                      <template>
                        <div class="form-control" style="display: flow-root;">
                          <span> {{ $t('Not sending message to the same person within') }}</span>
                          <span>
                            {{ intent.not_reply_within_seconds / 60 || '-' }}
                            {{ $t('minute') }}</span
                          >
                        </div>
                      </template>
                      <template>
                        <div class="form-control mt-2" style="display: flow-root;">
                          <span> {{ $t('Send message to same person') }}</span>
                          <span> {{ intent.not_reply_within_times || '-' }} {{ $t('time') }}</span>
                        </div>
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="7" :value="'tab-7'">
                <v-card flat>
                  <v-card-text>
                    <div>
                      <h4 class="mt-3 mb-2">
                        {{
                          $t(
                            'After sending this conversation, if there is no response from customers. The system will send messages to follow up them within 24 hours.'
                          )
                        }}
                      </h4>
                      <h4 class="mb-2" v-if="isCommentToInbox">
                        {{
                          $t(
                            `If user haven't sent message in inbox ,The follow-up message won't be sent`
                          )
                        }}
                      </h4>
                      <p>
                        {{ $t('status') }}
                        <span v-if="intent.follow_up_status">
                          <v-icon color="green">circle</v-icon> {{ $t('open') }}</span
                        ><span v-else> <v-icon color="red">circle</v-icon> {{ $t('close') }}</span>
                      </p>
                      <template v-if="!showMultipleChannelFollowUp">
                        <p>
                          <span
                            >{{
                              Math.floor(parseInt(intent.follow_up_within_seconds) / 60 / 60) ||
                                '00'
                            }}
                            {{ $t('hour') }}</span
                          >
                          <span
                            >{{ (parseInt(intent.follow_up_within_seconds) / 60) % 60 || '00' }}
                            {{ $t('minute') }}</span
                          >
                        </p>
                      </template>
                      <template v-else>
                        <p v-if="intent.follow_up_fb_within_seconds && tab2 == 'facebook'">
                          <span
                            >{{
                              Math.floor(parseInt(intent.follow_up_fb_within_seconds) / 60 / 60)
                                .toString()
                                .padStart(2, '0') || '00'
                            }}
                            {{ $t('hour') }}</span
                          >
                          <span>
                            {{
                              String(
                                parseInt(intent.follow_up_fb_within_seconds / 60) % 60 || '00'
                              ).padStart(2, '0')
                            }}

                            {{ $t('minute') }}</span
                          >
                        </p>
                        <p v-if="intent.follow_up_line_within_seconds && tab2 == 'line'">
                          <span
                            >{{
                              Math.floor(parseInt(intent.follow_up_line_within_seconds) / 86400)
                                .toString()
                                .padStart(2, '0') || '00'
                            }}
                            {{ $t('Days') }}</span
                          >
                          <span
                            >{{
                              Math.floor(
                                (parseInt(intent.follow_up_line_within_seconds) % 86400) / 3600
                              )
                                .toString()
                                .padStart(2, '0') || '00'
                            }}
                            {{ $t('hour') }}</span
                          >
                          <span
                            >{{
                              String(
                                parseInt(intent.follow_up_line_within_seconds / 60) % 60 || '00'
                              ).padStart(2, '0')
                            }}
                            {{ $t('minute') }}</span
                          >
                        </p>
                        <p v-if="intent.follow_up_ig_within_seconds && tab2 == 'instagram'">
                          <span
                            >{{
                              Math.floor(
                                (parseInt(intent.follow_up_line_within_seconds) % 86400) / 3600
                              )
                                .toString()
                                .padStart(2, '0') || '00'
                            }}
                            {{ $t('hour') }}</span
                          >
                          <span
                            >{{
                              String(
                                parseInt(intent.follow_up_ig_within_seconds / 60) % 60 || '00'
                              ).padStart(2, '0')
                            }}
                            {{ $t('minute') }}</span
                          >
                        </p>
                        <p v-if="intent.follow_up_google_within_seconds && tab2 == 'google'">
                          <span
                            >{{
                              Math.floor(parseInt(intent.follow_up_google_within_seconds) / 60 / 60)
                                .toString()
                                .padStart(2, '0') || '00'
                            }}
                            {{ $t('hour') }}</span
                          >
                          <span
                            >{{
                              String(
                                parseInt(intent.follow_up_google_within_seconds / 60) % 60 || '00'
                              ).padStart(2, '0')
                            }}
                            {{ $t('minute') }}</span
                          >
                        </p>
                      </template>

                      <template v-if="intent.follow_up_type == 'json'">
                        <div>
                          <v-layout>
                            <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                              <template v-if="isCommentToInbox">
                                <p class="mt-3">{{ $t('Chatbot answers') }}</p>
                                <template v-if="!showMultipleChannelFollowUp">
                                  <template v-if="answersFollowUp && answersFollowUp[0].length > 0">
                                    <message-viewer v-model="answersFollowUp"></message-viewer>
                                  </template>
                                  <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                                </template>
                                <template v-else>
                                  <v-layout>
                                    <v-flex
                                      class="channel"
                                      shrink
                                      style="border-right: 1px solid #eee"
                                    >
                                      <template v-for="(item, index) in commentChannelitem">
                                        <div
                                          :key="index"
                                          :class="{ 'primary white--text': tab2 == item.tab }"
                                          @click="tab2 = item.tab"
                                          class="py-1 pl-2 pr-2"
                                          style="
                                                    border: 1px solid #eee;
                                                    border-width: 1px 0px 1px 1px;
                                                    border-top-left-radius: 5px;
                                                    border-bottom-left-radius: 5px;
                                                    cursor: pointer;
                                                  "
                                        >
                                          <span :class="`fab ${item.icon}`"></span>
                                        </div>
                                      </template>
                                    </v-flex>
                                    <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                                      <template v-if="tab2 == 'facebook'">
                                        <template
                                          v-if="
                                            fbanswersFollowUp && fbanswersFollowUp[0].length > 0
                                          "
                                        >
                                          <message-viewer
                                            v-model="fbanswersFollowUp"
                                            :channel="tab2"
                                          ></message-viewer>
                                        </template>
                                        <p v-else class="primary-color pl-1">
                                          {{ $t('No reply') }}
                                        </p>
                                      </template>
                                      <template v-else-if="tab2 == 'instagram'">
                                        <template
                                          v-if="
                                            iganswersFollowUp && iganswersFollowUp[0].length > 0
                                          "
                                        >
                                          <message-viewer
                                            v-model="iganswersFollowUp"
                                            :channel="tab2"
                                          ></message-viewer>

                                          <v-premium-lock2
                                            :value="!check_privilege('instagram')"
                                            type="premium"
                                            class="mt-2"
                                          >
                                            <span class="pl-2">{{
                                              $t('Upgrade to Premium Plan')
                                            }}</span>
                                          </v-premium-lock2>
                                        </template>
                                        <p v-else class="primary-color pl-1">
                                          {{ $t('No reply') }}
                                        </p>
                                      </template>
                                    </v-flex>
                                  </v-layout>
                                </template>
                              </template>

                              <template v-else>
                                <p>{{ $t('Chatbot answers') }}</p>
                                <template v-if="intent.a_type == 'json'">
                                  <div>
                                    <template v-if="!showMultipleChannelFollowUp">
                                      <template
                                        v-if="answersFollowUp && answersFollowUp[0].length > 0"
                                      >
                                        <message-viewer
                                          v-model="answersFollowUp"
                                          :channel="tab2"
                                        ></message-viewer>
                                      </template>
                                      <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                                    </template>
                                    <template v-else>
                                      <v-layout>
                                        <v-flex
                                          class="channel"
                                          shrink
                                          style="border-right: 1px solid #eee"
                                        >
                                          <template v-for="(item, index) in channelItem">
                                            <div
                                              :key="index"
                                              v-if="item.name != 'whatsapp'"
                                              :class="{ 'primary white--text': tab2 == item.tab }"
                                              @click="tab2 = item.tab"
                                              class="py-1 pl-2 pr-2"
                                              style="
                                                    border: 1px solid #eee;
                                                    border-width: 1px 0px 1px 1px;
                                                    border-top-left-radius: 5px;
                                                    border-bottom-left-radius: 5px;
                                                    cursor: pointer;
                                                  "
                                            >
                                              <span :class="`fab ${item.icon}`"></span>
                                            </div>
                                          </template>
                                        </v-flex>
                                        <v-flex
                                          style="overflow: auto; min-height: 100px"
                                          class="ml-1"
                                        >
                                          <template v-if="tab2 == 'facebook'">
                                            <template
                                              v-if="
                                                fbanswersFollowUp && fbanswersFollowUp[0].length > 0
                                              "
                                            >
                                              <message-viewer
                                                v-model="fbanswersFollowUp"
                                                :channel="tab2"
                                              ></message-viewer>
                                            </template>
                                            <p v-else class="primary-color pl-1">
                                              {{ $t('No reply') }}
                                            </p>
                                          </template>
                                          <template v-else-if="tab2 == 'line'">
                                            <template
                                              v-if="
                                                lineanswersFollowUp &&
                                                  lineanswersFollowUp[0].length > 0
                                              "
                                            >
                                              <message-viewer
                                                v-model="lineanswersFollowUp"
                                                :channel="tab2"
                                              ></message-viewer>

                                              <v-premium-lock2
                                                :value="!check_privilege('line')"
                                                type="premium"
                                                class="mt-2"
                                              >
                                                <span class="pl-2">{{
                                                  $t('Upgrade to {package} Plan', {
                                                    package: $t('PREMIUM')
                                                  })
                                                }}</span>
                                              </v-premium-lock2>
                                            </template>
                                            <p v-else class="primary-color pl-1">
                                              {{ $t('No reply') }}
                                            </p>
                                          </template>
                                          <template v-else-if="tab2 == 'instagram'">
                                            <template
                                              v-if="
                                                iganswersFollowUp && iganswersFollowUp[0].length > 0
                                              "
                                            >
                                              <message-viewer
                                                v-model="iganswersFollowUp"
                                                :channel="tab2"
                                              ></message-viewer>

                                              <v-premium-lock2
                                                :value="!check_privilege('instagram')"
                                                type="premium"
                                                class="mt-2"
                                              >
                                                <span class="pl-2">{{
                                                  $t('Upgrade to Premium Plan')
                                                }}</span>
                                              </v-premium-lock2>
                                            </template>
                                            <p v-else class="primary-color pl-1">
                                              {{ $t('No reply') }}
                                            </p>
                                          </template>
                                          <template v-else-if="tab2 == 'whatsapp'">
                                            <template
                                              v-if="
                                                whatsappanswersFollowUp &&
                                                  whatsappanswersFollowUp[0].length > 0
                                              "
                                            >
                                              <message-viewer
                                                v-model="whatsappanswersFollowUp"
                                                :channel="tab2"
                                              ></message-viewer>

                                              <v-premium-lock2
                                                :value="!check_privilege('whatsapp')"
                                                type="premium"
                                                class="mt-2"
                                              >
                                                <span class="pl-2">{{
                                                  $t('Upgrade to {package} Plan', {
                                                    package: $t('PREMIUM')
                                                  })
                                                }}</span>
                                              </v-premium-lock2>
                                            </template>
                                            <p v-else class="primary-color pl-1">
                                              {{ $t('No reply') }}
                                            </p>
                                          </template>
                                          <template v-else-if="tab2 == 'google'">
                                            <template
                                              v-if="
                                                googleanswersFollowUp &&
                                                  googleanswersFollowUp[0].length > 0
                                              "
                                            >
                                              <message-viewer
                                                v-model="googleanswersFollowUp"
                                                :channel="tab2"
                                              ></message-viewer>

                                              <v-premium-lock2
                                                :value="!check_privilege('google')"
                                                type="premium"
                                                class="mt-2"
                                              >
                                                <span class="pl-2">{{
                                                  $t('Upgrade to Premium Plan')
                                                }}</span>
                                              </v-premium-lock2>
                                            </template>
                                            <p v-else class="primary-color pl-1">
                                              {{ $t('No reply') }}
                                            </p>
                                          </template>
                                        </v-flex>
                                      </v-layout>
                                    </template>
                                  </div>
                                </template>
                              </template>
                              <template>
                                <div v-if="!isCommentToInbox && tab2 !== 'whatsapp'">
                                  <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                                  <div class="quickreply">
                                    <template v-if="follow_up_quick_reply.length > 0">
                                      <ul class="tags">
                                        <li
                                          class="tag"
                                          v-for="(reply, index) in follow_up_quick_reply"
                                          :key="'follow_up_quick_reply' + index"
                                        >
                                          {{ reply }}
                                        </li>
                                      </ul>
                                    </template>
                                    <template v-else>-</template>
                                  </div>
                                </div>
                              </template>
                            </v-flex>
                          </v-layout>
                        </div>
                        <div>
                          <v-divider></v-divider>

                          <v-tabs slider-color="primary" touchless show-arrows>
                            <v-tab :key="0" :href="'#subtab-0'" ripple>{{ $t('Customer') }}</v-tab>
                            <v-tab :key="1" :href="'#subtab-1'" ripple v-if="!isCommentToInbox">{{
                              $t('Context')
                            }}</v-tab>
                            <v-tab :key="2" :href="'#subtab-2'" ripple>{{
                              $t('Line Notify')
                            }}</v-tab>
                            <v-tab-item :key="0" :value="'subtab-0'">
                              <v-card flat>
                                <v-card-text>
                                  <div>
                                    <div class="caption">{{ $t('Status') }}</div>
                                    <p class="primary-color">
                                      {{
                                        intent.follow_up_userstatus
                                          ? intent.follow_up_userstatus
                                          : '-'
                                      }}
                                    </p>
                                  </div>
                                  <div>
                                    <div class="caption">{{ $t('Tag') }}</div>
                                    <ul class="tags pt-1">
                                      <li
                                        class="tag"
                                        v-for="(usertag, index) in follow_up_usertags"
                                        :key="'usertag_' + index"
                                      >
                                        <specialtext :text="usertag"></specialtext>
                                      </li>
                                    </ul>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item :key="1" :value="'subtab-1'" v-if="!isCommentToInbox">
                              <v-card flat>
                                <v-card-text>
                                  <v-layout>
                                    <template>
                                      <v-flex>
                                        <div class="caption">Context Out</div>
                                        <p class="primary-color">
                                          {{
                                            intent.follow_up_context_out
                                              ? intent.follow_up_context_out
                                              : '-'
                                          }}
                                        </p>
                                      </v-flex>
                                    </template>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item :key="2" :value="'subtab-2'">
                              <v-card flat>
                                <v-card-text>
                                  <div class="caption">{{ $t('Line Notify') }}</div>
                                  <div class="primary-color">
                                    {{
                                      intent.follow_up_linenoti_text
                                        ? intent.follow_up_linenoti_text
                                        : '-'
                                    }}
                                  </div>

                                  <template v-if="intent.follow_up_linenoti_spec_ids">
                                    <div class="caption">{{ $t('Who to notify') }}</div>
                                    <template v-for="linenotify in $store.state.linenotifylist">
                                      <template
                                        v-if="
                                          intent.follow_up_linenoti_spec_ids.indexOf(
                                            linenotify.id
                                          ) != -1
                                        "
                                      >
                                        <v-chip :key="linenotify.id" class="v-chip--select-multi">
                                          <v-avatar>
                                            <img
                                              :src="
                                                `https://graph.facebook.com/${linenotify.adminid}/picture?type=square&SameSite=None`
                                              "
                                            />
                                          </v-avatar>
                                          {{ linenotify.name }}
                                        </v-chip>
                                      </template>
                                    </template>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>
                        </div>
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="8" :value="'tab-8'">
                <v-card flat>
                  <v-card-text>
                    <div>
                      <div class="caption">{{ $t('event') }}</div>
                      <p class="primary-color">
                        {{
                          intent.event_setting && intent.event_setting.event_name
                            ? intent.event_setting.event_name
                            : '-'
                        }}
                      </p>
                    </div>
                    <v-layout>
                      <v-flex xs6>
                        <div class="caption">{{ $t('Amount') }}</div>
                        <p class="primary-color">
                          <specialtext
                            :text="
                              intent.event_setting && intent.event_setting.value
                                ? intent.event_setting.value
                                : '-'
                            "
                          />
                        </p>
                      </v-flex>
                      <v-flex xs6>
                        <div class="caption">{{ $t('monetary_unit') }}</div>
                        <p class="primary-color">
                          {{
                            intent.event_setting && intent.event_setting.currency
                              ? intent.event_setting.currency
                              : '-'
                          }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
      </template>
    </div>
    <v-dialog v-model="dialogMember" scrollable max-width="300px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>เลือกสมาชิกกลุ่ม</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div style="position: absolute; right: 5px; top: 5px;">
          <v-btn color="white" fab small flat @click="dialogMember = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <v-list two-line>
          <template v-for="(item, index) in memberGroup">
            <v-divider :key="index + '_divider'"></v-divider>

            <v-list-tile :key="index + '_list'" avatar>
              <v-list-tile-avatar>
                <img :src="item.picture_url" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="item.display_name"></v-list-tile-title>
              </v-list-tile-content>
              <v-btn color="primary" @click="openGroupBill(item)">เลือก</v-btn>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showShare" max-width="290">
      <v-card>
        <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
          >{{ $t('Link Copied') }}!</v-snackbar
        >
        <v-layout wrap>
          <v-flex xs8 class=" pt-3 pl-3">{{ $t('Share Ref link') }}</v-flex>
          <v-flex xs4 class="text-xs-right">
            <v-btn fab flat small @click="showShare = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text class="pt-0">
          <div style="display: flex" class="pb-1" v-if="tabSelect">
            <div
              v-if="selectedBot.packages.includes('facebook')"
              class="py-1 pl-2 pr-2"
              style="border-radius: 4px 0px 0px 4px; border: solid 0.5px #ed1e79; cursor:pointer"
              :class="{ 'primary white--text': tabSelect == 'facebook' }"
              @click="tabSelect = 'facebook'"
            >
              <span class="fab fa-facebook"></span>
            </div>
            <div
              v-if="selectedBot.advancedExpriedDate > 0 && selectedBot.packages.includes('line')"
              :class="{ 'primary white--text': tabSelect == 'line' }"
              class=" py-1 pl-2 pr-2"
              @click="tabSelect = 'line'"
              style="border-radius: 0px 4px 4px 0px; border: solid 0.5px #ed1e79; cursor:pointer"
            >
              <span class="fab fa-line"></span>
            </div>
          </div>
          <textarea
            class="form-control pa-2"
            ref="shareLink"
            style="resize: vertical; width: 100%; border: 1px solid #eee;"
            onclick="this.select()"
            readonly="true"
            :value="tabSelect === 'facebook' ? messageShare : messageShareLine"
          ></textarea>
          <div class="text-xs-center">
            <v-btn
              depressed
              color="primary"
              v-clipboard:copy="tabSelect === 'facebook' ? messageShare : messageShareLine"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <span class="glyphicon glyphicon-file mr-1"></span>
              {{ $t('copy') }}
            </v-btn>
            <div>
              <small v-if="tabSelect == 'line'" class="caption warning--text">
                * {{ $t('users_can_only_use_the_link_via_mobile') }}
              </small>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialogChatGPT" width="1000px">
      <ModalChatGPT :answers="answers" :intent.sync="intent" :dialogChatGPT.sync="dialogChatGPT" />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import specialtext from '@/components/elements/specialtext'
import IntentGetstarted from './IntentGetstarted'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalChatGPT from '@/components/elements/ModalChatGPT'
import FacebookScreen from '@/components/elements/FacebookScreen'
import api from '@/api'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import dayjs from 'dayjs'
import { ToggleButton } from 'vue-js-toggle-button'
import IntentSelectPostLabel from './IntentSelectPostLabel'
import IntentGroupItem from './IntentGroupItem.js'
import { cloneDeep } from 'lodash'
import isBetween from 'dayjs/plugin/isBetween'
import axios from 'axios'
import IntentVerifySlip from './IntentVerifySlip.vue'
import OpenTimeBotItem from '../billing/OpenTimeBotItem'
dayjs.extend(isBetween)

const dayItems = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
const dayAbb = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
  Sunday: 'Sun'
}
const day = dayjs().day()
const dayMatch = dayItems[day === 0 ? dayItems.length : day - 1]
const today = dayjs().format('YYYY-MM-DD')

export default {
  props: [
    'isBeacon',
    'group_id',
    'value',
    'excludedIntentName',
    'isCommentToInbox',
    'filterIntents',
    'isLiveStream',
    'livechatapp',
    'isLivechat',
    'isIntent',
    'indexIntent',
    'pageNumber',
    'cbAll',
    'isConversation',
    'isComment',
    'isFirstAnnouncement'
  ],
  data: function() {
    return {
      dayjs,
      dataVerifySlip: [],
      messageShare: null,
      messageShareLine: null,
      showShare: false,
      showCopy: false,
      isEdit: false,
      intent: this.value,
      // showDetail: false,
      showPreview: false,
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],
      isOtherLang: false,
      advancedTab: null,
      showMultipleChannel: false,
      showMultipleChannelFollowUp: false,
      tab: 'all',
      tab2: 'all',
      channels: [],
      dialogMember: false,
      dialogChatGPT: false,
      // intentfollowUp: null
      fb_status: false,
      line_status: false,
      ig_status: false,
      whatsapp_status: false,
      google_status: false,
      tabSelect: null,
      isMetaVerifySlip: false,
      // verify slip
      messages: [[]],
      messages2: [[]],
      messages_correct: [[]],
      messages_incorrect: [[]],
      messages_error: [[]],
      messages_duplicate: [[]],
      fb_messages: [[]],
      fb_messages2: [[]],
      fb_messages_correct: [[]],
      fb_messages_incorrect: [[]],
      fb_messages_error: [[]],
      fb_messages_duplicate: [[]],
      line_messages: [[]],
      line_messages2: [[]],
      line_messages_correct: [[]],
      line_messages_incorrect: [[]],
      line_messages_error: [[]],
      line_messages_duplicate: [[]],
      whatsapp_messages: [[]],
      whatsapp_messages2: [[]],
      whatsapp_messages_correct: [[]],
      whatsapp_messages_incorrect: [[]],
      whatsapp_messages_error: [[]],
      whatsapp_messages_duplicate: [[]],
      ig_messages: [[]],
      ig_messages2: [[]],
      ig_messages_correct: [[]],
      ig_messages_incorrect: [[]],
      ig_messages_error: [[]],
      ig_messages_duplicate: [[]],
      google_messages: [[]],
      google_messages2: [[]],
      google_messages_correct: [[]],
      google_messages_incorrect: [[]],
      google_messages_error: [[]],
      google_messages_duplicate: [[]]
    }
  },
  mounted: async function() {
    const vm = this
    vm.getFbName(vm.intent.created_by)
    vm.getIntent()
    if (vm.intent) {
      vm.showMultipleChannelFollowUp =
        (vm.intent.follow_up_fb_val ||
          vm.intent.follow_up_line_val ||
          vm.intent.follow_up_ig_val ||
          vm.intent.follow_up_whatsapp_val ||
          vm.intent.follow_up_google_val) != null
      if (vm.showMultipleChannelFollowUp) {
        try {
          vm.tab2 = 'facebook'

          const fb_answers = JSON.parse(vm.intent.follow_up_fb_val)
          if (fb_answers.length > 0 && fb_answers[0].length > 0) {
            vm.channels.push('facebook')
          }

          const line_answers = JSON.parse(vm.intent.follow_up_line_val)
          if (line_answers.length > 0 && line_answers[0].length > 0) {
            vm.channels.push('line')
          }

          const whatsapp_answers = JSON.parse(vm.intent.follow_up_whatsapp_val)
          if (whatsapp_answers.length > 0 && whatsapp_answers[0].length > 0) {
            vm.channels.push('whatsapp')
          }

          const ig_answers = JSON.parse(vm.intent.follow_up_ig_val)
          if (ig_answers.length > 0 && ig_answers[0].length > 0) {
            vm.channels.push('instagram')
          }

          const google_answers = JSON.parse(vm.intent.follow_up_google_val)
          if (google_answers.length > 0 && google_answers[0].length > 0) {
            vm.channels.push('google')
          }

          if (vm.channels.length > 0) {
            vm.tab2 = vm.channels[0]
          }
        } catch (error) {
          vm.tab2 = 'facebook'
        }
      }

      if (vm.intent.verify_slip_setting && Object.keys(vm.intent.verify_slip_setting).length) {
        if (
          vm.intent.verify_slip_setting.correct_a_val &&
          vm.intent.verify_slip_setting.correct_a_val.length
        ) {
          vm.messages_correct[0].push(...vm.intent.verify_slip_setting.correct_a_val)
        }
        if (
          vm.intent.verify_slip_setting.incorrect_a_val &&
          vm.intent.verify_slip_setting.incorrect_a_val.length
        ) {
          vm.messages_incorrect[0].push(...vm.intent.verify_slip_setting.incorrect_a_val)
        }
        if (
          vm.intent.verify_slip_setting.error_a_val &&
          vm.intent.verify_slip_setting.error_a_val.length
        ) {
          vm.messages_error[0].push(...vm.intent.verify_slip_setting.error_a_val)
        }
        if (
          vm.intent.verify_slip_setting.duplicate_a_val &&
          vm.intent.verify_slip_setting.duplicate_a_val.length
        ) {
          vm.messages_duplicate[0].push(...vm.intent.verify_slip_setting.duplicate_a_val)
        }
        if (
          vm.intent.verify_slip_setting.correct_fb_val &&
          vm.intent.verify_slip_setting.correct_fb_val.length
        ) {
          vm.fb_messages_correct[0].push(...vm.intent.verify_slip_setting.correct_fb_val)
        }
        if (
          vm.intent.verify_slip_setting.incorrect_fb_val &&
          vm.intent.verify_slip_setting.incorrect_fb_val.length
        ) {
          vm.fb_messages_incorrect[0].push(...vm.intent.verify_slip_setting.incorrect_fb_val)
        }
        if (
          vm.intent.verify_slip_setting.error_fb_val &&
          vm.intent.verify_slip_setting.error_fb_val.length
        ) {
          vm.fb_messages_error[0].push(...vm.intent.verify_slip_setting.error_fb_val)
        }
        if (
          vm.intent.verify_slip_setting.duplicate_fb_val &&
          vm.intent.verify_slip_setting.duplicate_fb_val.length
        ) {
          vm.fb_messages_duplicate[0].push(...vm.intent.verify_slip_setting.duplicate_fb_val)
        }
        if (
          vm.intent.verify_slip_setting.correct_line_val &&
          vm.intent.verify_slip_setting.correct_line_val.length
        ) {
          vm.line_messages_correct[0].push(...vm.intent.verify_slip_setting.correct_line_val)
        }
        if (
          vm.intent.verify_slip_setting.incorrect_line_val &&
          vm.intent.verify_slip_setting.incorrect_line_val.length
        ) {
          vm.line_messages_incorrect[0].push(...vm.intent.verify_slip_setting.incorrect_line_val)
        }
        if (
          vm.intent.verify_slip_setting.error_line_val &&
          vm.intent.verify_slip_setting.error_line_val.length
        ) {
          vm.line_messages_error[0].push(...vm.intent.verify_slip_setting.error_line_val)
        }
        if (
          vm.intent.verify_slip_setting.duplicate_line_val &&
          vm.intent.verify_slip_setting.duplicate_line_val.length
        ) {
          vm.line_messages_duplicate[0].push(...vm.intent.verify_slip_setting.duplicate_line_val)
        }
        if (
          vm.intent.verify_slip_setting.correct_ig_val &&
          vm.intent.verify_slip_setting.correct_ig_val.length
        ) {
          vm.ig_messages_correct[0].push(...vm.intent.verify_slip_setting.correct_ig_val)
        }
        if (
          vm.intent.verify_slip_setting.incorrect_ig_val &&
          vm.intent.verify_slip_setting.incorrect_ig_val.length
        ) {
          vm.ig_messages_incorrect[0].push(...vm.intent.verify_slip_setting.incorrect_ig_val)
        }
        if (
          vm.intent.verify_slip_setting.error_ig_val &&
          vm.intent.verify_slip_setting.error_ig_val.length
        ) {
          vm.ig_messages_error[0].push(...vm.intent.verify_slip_setting.error_ig_val)
        }
        if (
          vm.intent.verify_slip_setting.duplicate_ig_val &&
          vm.intent.verify_slip_setting.duplicate_ig_val.length
        ) {
          vm.ig_messages_duplicate[0].push(...vm.intent.verify_slip_setting.duplicate_ig_val)
        }
        if (
          vm.intent.verify_slip_setting.correct_google_val &&
          vm.intent.verify_slip_setting.correct_google_val.length
        ) {
          vm.google_messages_correct[0].push(...vm.intent.verify_slip_setting.correct_google_val)
        }
        if (
          vm.intent.verify_slip_setting.incorrect_google_val &&
          vm.intent.verify_slip_setting.incorrect_google_val.length
        ) {
          vm.google_messages_incorrect[0].push(
            ...vm.intent.verify_slip_setting.incorrect_google_val
          )
        }
        if (
          vm.intent.verify_slip_setting.error_google_val &&
          vm.intent.verify_slip_setting.error_google_val.length
        ) {
          vm.google_messages_error[0].push(...vm.intent.verify_slip_setting.error_google_val)
        }
        if (
          vm.intent.verify_slip_setting.duplicate_google_val &&
          vm.intent.verify_slip_setting.duplicate_google_val.length
        ) {
          vm.google_messages_duplicate[0].push(
            ...vm.intent.verify_slip_setting.duplicate_google_val
          )
        }
        if (
          vm.intent.verify_slip_setting.correct_whatsapp_val &&
          vm.intent.verify_slip_setting.correct_whatsapp_val.length
        ) {
          vm.whatsapp_messages_correct[0].push(
            ...vm.intent.verify_slip_setting.correct_whatsapp_val
          )
        }
        if (
          vm.intent.verify_slip_setting.incorrect_whatsapp_val &&
          vm.intent.verify_slip_setting.incorrect_whatsapp_val.length
        ) {
          vm.whatsapp_messages_incorrect[0].push(
            ...vm.intent.verify_slip_setting.incorrect_whatsapp_val
          )
        }
        if (
          vm.intent.verify_slip_setting.error_whatsapp_val &&
          vm.intent.verify_slip_setting.error_whatsapp_val.length
        ) {
          vm.whatsapp_messages_error[0].push(...vm.intent.verify_slip_setting.error_whatsapp_val)
        }
        if (
          vm.intent.verify_slip_setting.duplicate_whatsapp_val &&
          vm.intent.verify_slip_setting.duplicate_whatsapp_val.length
        ) {
          vm.whatsapp_messages_duplicate[0].push(
            ...vm.intent.verify_slip_setting.duplicate_whatsapp_val
          )
        }
      } else if (
        this.check_privilege('multichannel') &&
        (vm.intent.fb_val ||
          vm.intent.line_val ||
          vm.intent.ig_val ||
          vm.intent.whatsapp_val ||
          vm.intent.google_val)
      ) {
        vm.showMultipleChannel = true
        vm.fb_messages_correct = JSON.parse(vm.intent.fb_val) || [[]]
        vm.fb_messages_incorrect = JSON.parse(vm.intent.fb_val) || [[]]
        vm.fb_messages_error = JSON.parse(vm.intent.fb_val) || [[]]
        vm.fb_messages_duplicate = JSON.parse(vm.intent.fb_val) || [[]]
        vm.line_messages_correct = JSON.parse(vm.intent.line_val) || [[]]
        vm.line_messages_incorrect = JSON.parse(vm.intent.line_val) || [[]]
        vm.line_messages_error = JSON.parse(vm.intent.line_val) || [[]]
        vm.line_messages_duplicate = JSON.parse(vm.intent.line_val) || [[]]
        vm.whatsapp_messages_correct = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.whatsapp_messages_incorrect = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.whatsapp_messages_error = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.whatsapp_messages_duplicate = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.ig_messages_correct = JSON.parse(vm.intent.ig_val) || [[]]
        vm.ig_messages_incorrect = JSON.parse(vm.intent.ig_val) || [[]]
        vm.ig_messages_error = JSON.parse(vm.intent.ig_val) || [[]]
        vm.ig_messages_duplicate = JSON.parse(vm.intent.ig_val) || [[]]
        vm.google_messages_correct = JSON.parse(vm.intent.google_val) || [[]]
        vm.google_messages_incorrect = JSON.parse(vm.intent.google_val) || [[]]
        vm.google_messages_error = JSON.parse(vm.intent.google_val) || [[]]
        vm.google_messages_duplicate = JSON.parse(vm.intent.google_val) || [[]]
        vm.tab = 'facebook'
      } else if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages_correct = JSON.parse(vm.value.a_val)
        vm.messages_incorrect = JSON.parse(vm.value.a_val)
        vm.messages_error = JSON.parse(vm.value.a_val)
        vm.messages_duplicate = JSON.parse(vm.value.a_val)
      }
    }
    if (vm.selectedBot.packages.includes('facebook')) {
      vm.tabSelect = 'facebook'
    } else if (vm.selectedBot.packages.includes('line')) {
      vm.tabSelect = 'line'
    }
  },
  components: {
    'manage-intent': manageIntent,
    specialtext,
    IntentGetstarted,
    GenericViewer,
    ModalDialog,
    ModalChatGPT,
    FacebookScreen,
    MessageViewer,
    ViewCartSummaryViewer,
    ToggleButton,
    IntentSelectPostLabel,
    IntentVerifySlip,
    OpenTimeBotItem
  },
  mixins: [IntentGroupItem],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      memberGroup: 'getMemberGroup'
      // welcomemessage: 'welcomeMessage',
    }),
    isVerifySlip() {
      return this.intent.q_val.includes('{verify_slip.bank_info')
    },
    isCheck() {
      if (this.cbAll && this.cbAll.length > 0) {
        return this.cbAll.includes(this.intent.id)
      }
    },
    adminName() {
      const vm = this
      if (vm.intent.updated_by) {
        if (/^\d+$/.test(vm.intent.updated_by)) {
          var result = vm.$store.state.facebook_users_name.find(el => el.id == vm.intent.updated_by)
          return result ? result.name : vm.intent.updated_by
        } else {
          return vm.intent.updated_by
        }
      } else if (vm.intent.created_by) {
        if (/^\d+$/.test(vm.intent.created_by)) {
          var result = vm.$store.state.facebook_users_name.find(el => el.id == vm.intent.created_by)
          return result ? result.name : vm.intent.created_by
        } else {
          return vm.intent.created_by
        }
      } else return ''
    },
    specificBeaconIds() {
      if (this.intent.specific_beacon_ids) {
        return this.intent.specific_beacon_ids.split(',')
      }
    },
    welcomemessage() {
      let { messages } = this.$store.getters.welcomeMessage(this.tab)

      return messages
    },
    intentStatus() {
      let vm = this
      let starttime = null
      let endtime = null
      let start = ''
      let end = ''
      let textDay = ''

      const todayInfo =
        vm.intent.onlytime === null && vm.intent.time_setting
          ? vm.intent.time_setting[dayMatch] || null
          : null
      if (vm.intent.onlytime === null && vm.intent.time_setting) {
        vm.intent.time_setting = {
          Monday: vm.intent.time_setting.Monday,
          Tuesday: vm.intent.time_setting.Tuesday,
          Wednesday: vm.intent.time_setting.Wednesday,
          Thursday: vm.intent.time_setting.Thursday,
          Friday: vm.intent.time_setting.Friday,
          Saturday: vm.intent.time_setting.Saturday,
          Sunday: vm.intent.time_setting.Sunday
        }

        if (todayInfo) {
          textDay = vm.$t(dayMatch)
          isStarttime = todayInfo.status
          isEndtime = todayInfo.status

          starttime = todayInfo.openat
            ? today + ' ' + dayjs(`${today}T${todayInfo.openat.slice(0, 5)}:00`).format('HH:mm')
            : today + ' ' + dayjs(`${today}T00:00:00`).format('HH:mm')

          start = todayInfo.openat
            ? dayjs(`${today}T${todayInfo.openat.slice(0, 5)}:00`).format('HH:mm')
            : dayjs(`${today}T00:00:00`).format('HH:mm')

          endtime =
            todayInfo.closeat && todayInfo.closeat.slice(0, 5) !== '24:00'
              ? today + ' ' + dayjs(`${today}T${todayInfo.closeat.slice(0, 5)}:00`).format('HH:mm')
              : today + ' ' + dayjs(`${today}T23:59:59`).format('HH:mm')

          end =
            todayInfo.closeat && todayInfo.closeat.slice(0, 5) !== '24:00'
              ? dayjs(`${today}T${todayInfo.closeat.slice(0, 5)}:00`).format('HH:mm')
              : '24:00'
        }
      } else {
        vm.intent.onlytime = vm.intent.onlytime === null ? false : vm.intent.onlytime
        starttime = vm.intent.starttime
          ? vm.intent.onlytime
            ? dayjs().format('YYYY-MM-DD') + ' ' + dayjs(vm.intent.starttime).format('HH:mm')
            : vm.intent.starttime
          : null
        endtime = vm.intent.endtime
          ? vm.intent.onlytime
            ? dayjs().format('YYYY-MM-DD') + ' ' + dayjs(vm.intent.endtime).format('HH:mm')
            : vm.intent.endtime
          : null
      }

      var isOnline = false
      var isStarttime = false
      var isEndtime = false
      let intentstatus = null
      if (this.isBeacon) {
        intentstatus = this.intent.status
      } else {
        intentstatus = this.intent.intentstatus
      }

      if (endtime == null && starttime == null) {
        isOnline = intentstatus
      } else if (starttime == null && dayjs() < dayjs(endtime)) {
        isOnline = intentstatus
        isEndtime = true
      } else if (endtime == null && dayjs() > dayjs(starttime)) {
        isOnline = intentstatus
        isStarttime = true
      } else if (dayjs(endtime) < dayjs(starttime)) {
        isOnline = intentstatus && (dayjs() >= dayjs(starttime) || dayjs() <= dayjs(endtime))
        isStarttime = isEndtime = dayjs() >= dayjs(starttime) || dayjs() <= dayjs(endtime)
      } else {
        isOnline = intentstatus && dayjs().isBetween(dayjs(starttime), dayjs(endtime))
        isStarttime = isEndtime = dayjs().isBetween(dayjs(starttime), dayjs(endtime))
      }

      return {
        isOnline: isOnline,
        isStarttime: isStarttime,
        isEndtime: isEndtime,
        start,
        end,
        textDay,
        todayStatus: Boolean(todayInfo && todayInfo.status)
      }
    },
    timeSetting() {
      if (this.intent.onlytime === null && this.intent.time_setting) {
        let days = []
        for (const key of Object.keys(this.intent.time_setting)) {
          const timeSettingInfo = this.intent.time_setting[key]

          const open = !timeSettingInfo.openat
            ? '00:00'
            : dayjs(`${today}T${timeSettingInfo.openat.slice(0, 5)}:00`).format('HH:mm')

          const close =
            !timeSettingInfo.closeat || timeSettingInfo.closeat.slice(0, 5) === '24:00'
              ? '24:00'
              : dayjs(`${today}T${timeSettingInfo.closeat.slice(0, 5)}:00`).format('HH:mm')

          let start = null
          let end = null

          start = timeSettingInfo.openat
            ? today +
              ' ' +
              dayjs(`${today}T${timeSettingInfo.openat.slice(0, 5)}:00`).format('HH:mm')
            : today + ' ' + dayjs(`${today}T00:00:00`).format('HH:mm')

          end =
            timeSettingInfo.closeat && timeSettingInfo.closeat.slice(0, 5) !== '24:00'
              ? today +
                ' ' +
                dayjs(`${today}T${timeSettingInfo.closeat.slice(0, 5)}:00`).format('HH:mm')
              : today + ' ' + dayjs(`${today}T23:59:59`).format('HH:mm')

          const inTime =
            (!timeSettingInfo.closeat && !timeSettingInfo.openat) ||
            (start && end && dayjs().isBetween(dayjs(start), dayjs(end)))

          days.push({
            ...timeSettingInfo,
            isToday: dayMatch === key,
            isActive: dayMatch === key && timeSettingInfo.status && inTime,
            day: this.$t(dayAbb[key]),
            timeLength: `${open} - ${close}`
          })
        }
        return days
      } else {
        return []
      }
    },
    questions: function() {
      if (this.intent.q_val !== '') {
        return this.intent.q_val.split(',')
      } else {
        return ''
      }
    },
    answers: function() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.a_val, vm.intent.a_type)
      } catch (error) {
        return [[]]
      }
    },
    fbanswers() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.fb_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    lineanswers() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.line_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    whatsappanswers() {
      const vm = this
      try {
        return vm.formatAnswer(vm.intent.whatsapp_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    iganswers() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.ig_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    googleAnswers() {
      const vm = this
      try {
        return vm.formatAnswer(vm.intent.google_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    answersFollowUp: function() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.follow_up_val, vm.intent.follow_up_type)
      } catch (error) {
        return [[]]
      }
    },
    fbanswersFollowUp() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.follow_up_fb_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    lineanswersFollowUp() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.follow_up_line_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    whatsappanswersFollowUp() {
      const vm = this
      try {
        return vm.formatAnswer(vm.intent.follow_up_whatsapp_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    iganswersFollowUp() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.follow_up_ig_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    googleanswersFollowUp() {
      const vm = this
      try {
        return this.formatAnswer(vm.intent.follow_up_google_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    replies: function() {
      const vm = this
      let reply = ''
      if (vm.tab == 'all') {
        reply = vm.intent.quick_reply
      } else if (vm.tab == 'facebook') {
        reply = vm.intent.fb_quick_reply
      } else if (vm.tab == 'line') {
        reply = vm.intent.line_quick_reply
      } else if (vm.tab == 'instagram') {
        reply = vm.intent.ig_quick_reply
      } else if (vm.tab == 'google') {
        reply = vm.intent.google_quick_reply
      } else if (vm.tab == 'whatsapp') {
        reply = vm.intent.whatsapp_quick_reply
      }
      if (reply && reply !== '' && reply != null) {
        const replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_quick_reply: function() {
      const vm = this
      let reply = ''
      if (vm.tab2 == 'all') {
        reply = vm.intent.follow_up_quick_reply
      } else if (vm.tab2 == 'facebook') {
        reply = vm.intent.follow_up_fb_quick_reply
      } else if (vm.tab2 == 'line') {
        reply = vm.intent.follow_up_line_quick_reply
      } else if (vm.tab2 == 'instagram') {
        reply = vm.intent.follow_up_ig_quick_reply
      } else if (vm.tab2 == 'google') {
        reply = vm.intent.follow_up_google_quick_reply
      } else if (vm.tab2 == 'whatsapp') {
        reply = vm.intent.follow_up_whatsapp_quick_reply
      }
      if (reply && reply !== '' && reply != null) {
        const replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    usertags: function() {
      var vm = this
      if (vm.intent.usertags !== '' && vm.intent.usertags != null) {
        var usertags = vm.intent.usertags.split(',')
        return usertags
      } else {
        return []
      }
    },
    follow_up_usertags: function() {
      var vm = this
      if (vm.intent.follow_up_usertags !== '' && vm.intent.follow_up_usertags != null) {
        var usertags = vm.intent.follow_up_usertags.split(',')
        return usertags
      } else {
        return []
      }
    },
    postidlist: function() {
      var vm = this
      var includes = []
      var excludes = []
      var keywords = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      if (vm.intent.post_keywords && vm.intent.post_keywords !== '') {
        try {
          keywords = JSON.parse(vm.intent.post_keywords)
        } catch (error) {
          keywords = vm.intent.post_keywords.split(',')
        }
      }
      return { includes: includes, excludes: excludes, post_keywords: keywords }
    },
    showDetail: function() {
      if (!this.isEdit) {
        return this.intent.isShow
      } else {
        return true
      }
    }
  },
  methods: {
    assignCb(id) {
      this.$emit('assignCb', id)
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    async getIntent() {
      const vm = this
      const packages = vm.selectedBot.packages
      vm.fb_status = packages.includes('facebook') ? true : false
      vm.line_status = packages.includes('line') ? true : false
      vm.ig_status = packages.includes('instagram') ? true : false
      vm.whatsapp_status = packages.includes('whatsapp') ? true : false
      vm.google_status = packages.includes('google') ? true : false
      if (vm.intent) {
        vm.formatData(vm.intent.q_val)
        vm.channels = []
        vm.showMultipleChannel =
          (vm.intent.fb_val ||
            vm.intent.line_val ||
            vm.intent.ig_val ||
            vm.intent.whatsapp_val ||
            vm.intent.google_val) != null
        if (vm.showMultipleChannel) {
          try {
            vm.tab = 'facebook'

            const fb_answers = JSON.parse(vm.intent.fb_val)
            if (fb_answers.length > 0 && fb_answers[0].length > 0 && vm.fb_status) {
              vm.channels.push('facebook')
            }

            const line_answers = JSON.parse(vm.intent.line_val)
            if (line_answers.length > 0 && line_answers[0].length > 0 && vm.line_status) {
              vm.channels.push('line')
            }

            const ig_answers = JSON.parse(vm.intent.ig_val)
            if (ig_answers.length > 0 && ig_answers[0].length > 0 && vm.ig_status) {
              vm.channels.push('instagram')
            }

            const whatsapp_answers = JSON.parse(vm.intent.whatsapp_val)
            if (
              whatsapp_answers.length > 0 &&
              whatsapp_answers[0].length > 0 &&
              vm.whatsapp_status
            ) {
              vm.channels.push('whatsapp')
            }

            const google_answers = JSON.parse(vm.intent.google_val)
            if (google_answers.length > 0 && google_answers[0].length > 0 && vm.google_status) {
              vm.channels.push('google')
            }

            if (vm.channels.length > 0) {
              vm.tab = vm.channels[0]
            }
          } catch (error) {
            vm.tab = 'facebook'
          }
        }
      }
    },
    getBankName(bankName) {
      const vm = this
      let bankAlltype = vm.$store.state.bankForVerify.concat(vm.$store.state.eWalletForVerify)
      bankAlltype = bankAlltype.concat(vm.$store.state.paymentGateway)
      return bankAlltype.filter(bankInfo => bankInfo.value === bankName)[0]
    },
    onCopy: function() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onError: function() {},

    async testIntent() {
      const vm = this
      if (
        vm.normal.length > 0 ||
        vm.keyword.length > 0 ||
        vm.exactly.length > 0 ||
        vm.startwith.length > 0 ||
        vm.endwith.length > 0 ||
        vm.startandendwith.length > 0
      ) {
        let text = ''

        if (vm.normal.length > 0) text = vm.normal[0].text
        else if (vm.keyword.length > 0) text = vm.keyword[0].text
        else if (vm.exactly.length > 0) text = vm.exactly[0].text
        else if (vm.startwith.length > 0) text = vm.startwith[0].text
        else if (vm.endwith.length > 0) text = vm.endwith[0].text
        else if (vm.startandendwith.length > 0) text = vm.startandendwith[0].text

        if (text.trim() != '') {
          vm.messageShare = `https://m.me/${
            vm.selectedBot.facebook_page_id
              ? vm.selectedBot.facebook_page_id
              : vm.selectedBot.pageid
          }?ref=${text.replace('&&', ' ')}`
          vm.messageShareLine = `https://line.me/R/oaMessage/${encodeURI(
            this.$store.state.selectedBot.line_oa_basic_id
          )}/?${encodeURI(text.replace('&&', ' '))}`
          vm.showShare = true
        }
      }
    },
    onChangeIntentStatus: function() {
      let intentstatus = null
      if (this.intent.intentname === '{first_announcement_message}' && !this.intent.id) {
        this.intent.intentstatus = !this.intent.intentstatus
        return
      } else if (this.isBeacon) {
        intentstatus = this.intent.status ? this.intent.status : false
        this.$set(this.intent, 'status', !intentstatus)
      } else {
        intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
        this.$set(this.intent, 'intentstatus', !intentstatus)
      }
      let data = {
        ...this.intent
      }
      var vm = this
      vm.$store.dispatch('loading')

      if (this.isBeacon) {
        api
          .editIntentBecon(data, function(error, response) {
            if (error) {
              console.error(error)
              vm.$store.dispatch('loading')
              return
            }
            vm.$store.dispatch('loading')
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        api
          .editIntent(data, function(error, response) {
            if (error) {
              if (response.result === 'DUPLICATE_INTENT_NAME') {
                vm.$swal({
                  title: vm.$t('Error'),
                  type: 'error',
                  text: vm.$t('duplicate_conversation_name'),
                  confirmButtonText: vm.$t('Confirm')
                })
              }
              console.error(error)
              vm.$store.dispatch('loading')
              return
            }
            vm.$store.dispatch('loading')
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    editIntent() {
      if (this.intent.intentname === '{default_gpt}') {
        this.dialogChatGPT = true
      } else {
        this.isEdit = true
        this.$store.commit('ADD_EDITTING_INTENT', this.intent.id)
      }
    },

    openGroupBill(user) {
      const vm = this
      let a_val = ''
      if (
        vm.intent.fb_val ||
        vm.intent.line_val ||
        vm.intent.ig_val ||
        vm.intent.whatsapp_val ||
        vm.intent.google_val
      ) {
        if (vm.livechatapp == 'facebook') {
          a_val = vm.intent.fb_val
        } else if (vm.livechatapp == 'line') {
          a_val = vm.intent.line_val
        } else if (vm.livechatapp == 'whatsapp') {
          a_val = vm.intent.whatsapp_val
        } else if (['instagram', 'instagram'].includes(vm.livechatapp)) {
          a_val = vm.intent.ig_val
        } else if (vm.livechatapp == 'google') {
          a_val = vm.intent.google_val
        }
      } else {
        a_val = vm.intent.a_val
      }
      vm.$emit(
        'sendToLivechat',
        {
          a_val: a_val,
          context_in: vm.intent.context_in,
          context_out: vm.intent.context_out,
          quick_reply: vm.intent.quick_reply,
          userstatus: vm.intent.userstatus,
          usertags: vm.intent.usertags
        },
        user.userid
      )
    },
    sendToLivechat(intent) {
      const vm = this
      if (
        vm.group_id &&
        (intent.a_val.includes('{addtocart') ||
          intent.a_val.includes('{removetocart') ||
          intent.a_val.includes('{removeandaddtocart') ||
          intent.a_val.includes('{shopurl') ||
          intent.a_val.includes('{salepage'))
      ) {
        vm.dialogMember = true
      } else {
        let a_val = ''
        if (
          intent.fb_val ||
          intent.line_val ||
          intent.ig_val ||
          vm.intent.whatsapp_val ||
          intent.google_val
        ) {
          if (vm.livechatapp == 'facebook') {
            a_val = intent.fb_val
          } else if (vm.livechatapp == 'line') {
            a_val = intent.line_val
          } else if (vm.livechatapp == 'whatsapp') {
            a_val = intent.whatsapp_val
          } else if (['instagram', 'instagram'].includes(vm.livechatapp)) {
            a_val = intent.ig_val
          } else if (vm.livechatapp == 'google') {
            a_val = intent.google_val
          }
        } else {
          a_val = intent.a_val
        }
        vm.$emit('sendToLivechat', {
          a_val: a_val,
          context_in: intent.context_in,
          context_out: intent.context_out,
          quick_reply: intent.quick_reply,
          userstatus: intent.userstatus,
          usertags: intent.usertags
        })
        vm.onClose()
      }
    },
    onSave: function(payload) {
      const vm = this

      vm.showMultipleChannel =
        vm.intent.fb_val != null ||
        vm.intent.line_val ||
        vm.intent.ig_val != null ||
        vm.intent.whatsapp_val != null ||
        vm.intent.google_val != null
      vm.getIntent()

      vm.showMultipleChannelFollowUp =
        vm.intent.follow_up_fb_val != null ||
        vm.intent.follow_up_line_val ||
        vm.intent.follow_up_ig_val != null ||
        vm.intent.follow_up_whatsapp_val != null
      vm.intent.follow_up_google_val || vm.intent.follow_up_ig_val != null
      if (vm.showMultipleChannelFollowUp) {
        try {
          vm.tab2 = 'facebook'
          const line_answers = JSON.parse(vm.intent.follow_up_line_val)
          if (line_answers.length > 0 && line_answers[0].length > 0) {
            vm.tab2 = 'line'
            vm.channels.push('line')
          }
          const whatsapp_answers = JSON.parse(vm.intent.follow_up_whatsapp_val)
          if (whatsapp_answers.length > 0 && whatsapp_answers[0].length > 0) {
            vm.tab2 = 'whatsapp'
            vm.channels.push('whatsapp')
          }
          const ig_answers = JSON.parse(vm.intent.follow_up_ig_val)
          if (ig_answers.length > 0 && ig_answers[0].length > 0) {
            vm.tab2 = 'instagram'
            vm.channels.push('instagram')
          }
          const google_answers = JSON.parse(vm.intent.follow_up_google_val)
          if (google_answers.length > 0 && google_answers[0].length > 0) {
            vm.tab2 = 'google'
            vm.channels.push('google')
          }
          const fb_answers = JSON.parse(vm.intent.follow_up_fb_val)
          if (fb_answers.length > 0 && fb_answers[0].length > 0) {
            vm.channels.push('facebook')
          }
        } catch (error) {
          vm.tab = 'facebook'
        }
      }
      vm.$store.commit('REMOVE_EDITTING_INTENT', vm.intent.id)
      vm.isEdit = false
      const intent =  document.getElementById(`select_intent${vm.intent.id}`)
      if (intent) {
        window.scrollTo({
          top: intent.offsetTop - 40,
          behavior: 'smooth'
        })
      }
    },
    onClose: function(payload) {
      this.$store.commit('REMOVE_EDITTING_INTENT', this.intent.id)
      this.isEdit = false
    },
    toggleDetail: function() {
      if (this.intent.intentname === '{default_gpt}') return

      this.intent.isShow = !this.intent.isShow
    },
    onCopyMyIntent: function() {
      let vm = this
      const { userid: userId } = vm.$store.state
      let data = {
        ...cloneDeep(vm.intent),
        created_at: new Date(),
        created_by: userId,
        updated_at: new Date(),
        updated_by: userId
      }
      data.pageid = vm.selectedBot.pageid

      if (vm.isBeacon) {
        data.campaign_name = data.campaign_name + '_' + dayjs().format('x')
      } else {
        data.intentname = data.intentname + '_copy'
      }
      data.a_val = data.a_val.replace(/ /gim, ' ')

      this.$emit('onCopyIntent', {
        onCopy: function() {
          return new Promise(async (resolve, reject) => {
            var result = await vm.$swal.fire({
              title: vm.$t('Do you want to copy {name}?', {
                name: vm.isBeacon
                  ? vm.intent.campaign_name.replace(/\<|\>/g, '').replaceAll('&not', '&amp;not')
                  : vm.intent.intentname.replace(/\<|\>/g, '').replaceAll('&not', '&amp;not')
              }),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
            if (result.value) {
              vm.$store.dispatch('loading')
              if (vm.isBeacon) {
                api.addIntentBecon(data, function(error, response) {
                  if (error) {
                    if (response.result === 'DUPLICATE_INTENT_NAME') {
                      vm.$swal({
                        title: vm.$t('Error'),
                        type: 'error',
                        text: vm.$t('duplicate_conversation_name'),
                        confirmButtonText: vm.$t('Confirm')
                      })
                    }
                    console.error(error)
                    vm.$store.dispatch('loading')
                    return
                  }
                  data.id = response.id
                  resolve(data)
                  vm.$store.dispatch('loading')
                })
              } else {
                api.addIntent(data, function(error, response) {
                  if (error) {
                    if (response.result === 'DUPLICATE_INTENT_NAME') {
                      vm.$swal({
                        title: vm.$t('Error'),
                        type: 'error',
                        text: vm.$t('duplicate_conversation_name'),
                        confirmButtonText: vm.$t('Confirm')
                      })
                    }
                    console.error(error)
                    vm.$store.dispatch('loading')
                    return
                  }
                  data.id = response.id
                  resolve(data)
                  vm.$store.dispatch('loading')
                })
              }
            }
          })
        }
      })
    },
    formatData: function(text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      var isPremium = vm.$store.getters.getPackage === 'premium'
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function(question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({
              text: keyword.trim(),
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else {
            vm.normal.push({ text: question, checkLang: vm.isSupportLanguage(question, isPremium) })
            if (!vm.isSupportLanguage(question, isPremium)) {
              vm.isOtherLang = true
            }
          }
        })
        vm.dataVerifySlip = []
        if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.bank_info')) {
          try {
            const textSplitValue = vm.normal[0].text.split('{verify_slip.bank_info=')
            const textSplitValue2 = textSplitValue[1].split(',')
            const dataValue = textSplitValue2[0].split('^')
            dataValue[dataValue.length - 1] = dataValue[dataValue.length - 1].split('}')[0]
            dataValue.map((item, index) => {
              let typeAccount = null
              if (item.split('|')[0] === 'promptpay') {
                typeAccount = { value: 'promptpay', label: 'Promptpay' }
              } else if (item.split('|')[0].includes('ew')) {
                typeAccount = { value: 'eWallet', label: 'E-Wallet' }
              } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
                typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
              } else {
                typeAccount = { value: 'transfer', label: 'Transfer' }
              }
              let keyword = []
              if (item.split('|') && item.split('|')[2]) {
                item
                  .split('|')[2]
                  .split('!')
                  .forEach(element => {
                    keyword.push({ text: element })
                  })
              }
              vm.dataVerifySlip.push({
                id: `${dayjs().format('x')}_${index}`,
                typeAccount: typeAccount,
                bankAccountNo: item.split('|')[1],
                bankName: item.split('|')[0],
                keyword: keyword
              })
            })
          } catch (error) {
            console.error(error)
          }
        } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.image}')) {
          vm.dataVerifySlip[0] = {
            id: dayjs().format('x'),
            typeAccount: { value: 'all', label: 'All' },
            bankAccountNo: '',
            bankName: ''
          }
        } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{meta_pay_verified}')) {
          vm.isMetaVerifySlip = true
          vm.dataVerifySlip = vm.$store.state.metaVerifySlip
        }
      }
    },
    async getFbName(userid) {
      const vm = this
      const fbusersname = vm.$store.state.facebook_users_name
      if (
        !fbusersname.some(el => el.id == userid) &&
        typeof userid !== 'undefined' &&
        userid !== null &&
        !userid.includes('zwiz')
      )
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    },
    onChangeChannel(tab) {
      if (this.getChannelDisabled(tab)) return
      this.tab = tab
    },
    getChannelDisabled(channel) {
      const advancedExpired = this.selectedBot.advanced_expireat || null
      if (!advancedExpired) {
        return channel !== 'facebook'
      } else {
        let a = dayjs(advancedExpired)
        let b = dayjs()
        const isOutOfTime = b.diff(a, 'days') > 0
        return isOutOfTime && channel !== 'facebook'
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.intent = newVal
      // this.showDetail = newVal.isShow
    },
    cbAll(newVal) {
      if (this.cbAll.includes(newVal.id)) this.cb = true
      else this.cb = false
    },
    'intent.q_val': function(newVal, oldVal) {
      const vm = this
      vm.formatData(vm.intent.q_val)
      vm.showMultipleChannel =
        (vm.intent.fb_val ||
          vm.intent.line_val ||
          vm.intent.ig_val ||
          vm.intent.whatsapp_val ||
          vm.intent.google_val) != null
    },
    'value.isShow': function(newVal) {
      // this.showDetail = newVal
    },
    intent: function(newVal) {
      this.$emit('onUpdate', newVal)
      // this.intent = Object.assign({},newVal)
    }
  }
}
</script>
<style lang="scss" scope>
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0;
}
.v-messages {
  min-height: 0;
}
.v-input {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  font-size: 16px;
  text-align: left;
  // justify-content: end;
}

.tab-channel {
  position: relative;
  border: 1px solid #eee;
  border-width: 1px 0px 1px 1px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 4px 8px;
  cursor: pointer;

  .lock {
    position: absolute;
    right: -3.5px;
    top: -4px;

    .v-chip {
      &.v-chip--small {
        height: 12px !important;
      }
      .v-chip__content {
        padding: 2px 4px !important;
        text-align: center;

        i {
          font-size: 10px !important;
        }
      }
    }
  }

  // font-size: 11px;

  &.disabled {
    cursor: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/intent-item.vue